import Vue from "vue"
import { v1 } from "uuid"
import instance from "../interceptor"
import api from "../api/index"
import { componentNames } from "dependencies/base"
import $ from "jquery"
import { historyIgnoreWrap } from "utils/revork"
import { text_children } from "../materials/text/menus/index"
import { image_children } from "../materials/image/menus/index"
import { button_children } from "../materials/button/menus/index"
import { data_dictionary_map_new } from "root/static/dataDictionary.js"
import { YZ_DATACENTER_TYPES } from "@/consts"
const text_children_temp = JSON.parse(JSON.stringify(text_children[0].attribute.options))
const image_children_temp = JSON.parse(JSON.stringify(image_children[0].attribute.options))
const button_children_temp = JSON.parse(JSON.stringify(button_children[0].attribute.options))
delete text_children_temp.lineHeightType
const uuid = { v1 }
import { CATEGORY_MODE } from "@/consts/index.js"
let APPIDLIST = [] // 当前webjson中存在的appId集合
let appList = [] // 当前webjson中存在的appId集合
// 需要进行px转换的属性
export const PXRESEVERPROP = [
  "width",
  "height",
  "left",
  "top",
  "fontSize",
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomLeftRadius",
  "borderBottomRightRadius",
  "borderWidth",
  "borderW",
  "boxShadowH",
  "boxShadowV",
  "boxShadowBlur",
  "boxShadowSpread",
  "liBoxShadowH",
  "liBoxShadowV",
  "liBoxShadowBlur",
  "liBoxShadowSpread",
  "textIndent",
  "padding",
  "paddingTop",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "lineHeight",
  "hoverLineHeight",
  "hoverLetterSpacing",
  "hoverLetterSpacing",
  "tabWidth",
  "tabHeight",
  "anchorWidth",
  "anchorHeight",
  "marginRight",
  "hoverUnderlineWidth",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "buttonIconSize",
  "buttonIconPadding",
  "buttonIconTop",
  "bulletsMargin",
  "bulletsSize",
  "buttonIconBackgroundWidth",
  "buttonIconBackGroundBorderRadius",
  "buttonIconBackgroundHeight",
  "iconWidth",
  "letterSpacing",
  "iconMargin",
  "hoverBorderTopLeftRadius",
  "hoverBorderTopRightRadius",
  "hoverHeight",
  "hoverBorderBottomRightRadius",
  "hoverBorderBottomLeftRadius",
  "progressbarHeight",
  "pageWidth",
  "font-size",
  "line-height",
  "topNavBorderBottomLeftRadius",
  "topNavBorderBottomRightRadius",
  "topNavBorderTopRightRadius",
  "topNavBorderTopLeftRadius",
  "topNavPaddingTop",
  "topNavPaddingRight",
  "topNavPaddingLeft",
  "topNavPaddingBottom",
  "liHoverFontSize",
  "navWidth",
  "selectFontSize",
  "liHeight",
  "liWidth",
  "liFontSize",
  "activeFontSize",
  "hoverFontSize",
  "liHoverFontSize",
  "titleOptionsHeight",
  "titleOptionsWidth",
  "headerHeight",
  "headerFontSize",
  "rowsHeight",
  "defaultFontSize",
  "specialFontSize",
  "selectCellFontSize",
  "pageTurnFontSize",
  "pageTurnHeight",
  "pageTurnMinWidth",
  "pageTurnPadding",
  "pageTurnPaddingTop",
  "pageTurnPaddingBottom",
  "pageTurnPaddingLeft",
  "pageTurnPaddingRight",
  "pageTurnBorderTopLeftRadius",
  "pageTurnBorderTopRightRadius",
  "pageTurnBorderBottomLeftRadius",
  "pageTurnBorderBottomRightRadius",
  "hoverPageTurnPadding",
  "hoverPageTurnPaddingTop",
  "hoverPageTurnPaddingBottom",
  "hoverPageTurnPaddingLeft",
  "hoverPageTurnPaddingRight",
  "hoverPageTurnBorderTopLeftRadius",
  "hoverPageTurnBorderTopRightRadius",
  "hoverPageTurnBorderBottomLeftRadius",
  "hoverPageTurnBorderBottomRightRadius",
  "allPadding",
  "allPaddingTop",
  "allPaddingBottom",
  "allPaddingLeft",
  "allPaddingRight",
  "minWidth",
  "margin",
  "iconWidth",
  "iconHeight",
  "activeLineHeight",
  "hoverLineHeight",
  "indent",
  "otherFontSize",
  "hoverPaddingTop",
  "hoverPaddingRight",
  "hoverPaddingLeft",
  "hoverPaddingBottom",
  "activePaddingTop",
  "activePaddingRight",
  "activePaddingLeft",
  "activePaddingBottom",
  "hoverPadding",
  "activePadding",
  "iconRadius",
  "itemMargin",
  "allBorderTopLeftRadius",
  "allBorderTopRightRadius",
  "allBorderBottomRightRadius",
  "allBorderBottomLeftRadius",
  "liActiveFontSize",
  "activeFontSize",
  "liActiveLetterSpacing",
  "symbolSize",
  "barBorderTopLeftRadius",
  "barBorderTopRightRadius",
  "barBorderBottomRightRadius",
  "barBorderBottomLeftRadius",
  "iconBorderWidth",
  "topNavMarginBottom",
  "liMarginBottom",
  "topNavBorderRadius1",
  "topNavBorderTopLeftRadius1",
  "topNavBorderTopRightRadius1",
  "topNavBorderBottomRightRadius1",
  "topNavBorderBottomLeftRadius1",
  "liLineHeight",
  "liActiveLineHeight",
  "liHoverLineHeight",
  "activityFontSize",
  "activityBorderTopLeftRadius",
  "activityBorderTopRightRadius",
  "activityBorderBottomRightRadius",
  "activityBorderBottomLeftRadius",
  "liBorderTopLeftRadius",
  "liBorderTopRightRadius",
  "liBorderBottomRightRadius",
  "liBorderBottomLeftRadius",
  "maxWidth",
  "maxHeight",
  "minHeight",
  "topNavActiveBorderTopLeftRadius",
  "topNavActiveBorderTopRightRadius",
  "topNavActiveBorderBottomRightRadius",
  "topNavActiveBorderBottomLeftRadius",
  "topNavHoverBorderTopLeftRadius",
  "topNavHoverBorderTopRightRadius",
  "topNavHoverBorderBottomRightRadius",
  "topNavHoverBorderBottomLeftRadius",
  "liHoverBorderTopLeftRadius",
  "liHoverBorderTopRightRadius",
  "liHoverBorderBottomRightRadius",
  "liHoverBorderBottomLeftRadius",
  "liIconWidth",
  "liIconHeight",
  "liIconMargin",
  "liBorderTopLeftRadius",
  "liBorderTopRightRadius",
  "liBorderBottomRightRadius",
  "liBorderBottomLeftRadius",
  "liPaddingTop",
  "liPaddingRight",
  "liPaddingLeft",
  "liPaddingBottom",
  "liMargin",
  "ulBorderWidth",
  "ulBorderTopLeftRadius",
  "ulBorderTopRightRadius",
  "ulBorderBottomRightRadius",
  "ulBorderBottomLeftRadius",
  "ulPaddingTop",
  "ulPaddingRight",
  "ulPaddingLeft",
  "ulPaddingBottom",
  "navHeight",
  "ulWidth",
  "ulHeight",
  "navMargin",
  "emptyFontSize",
  "iconMarginBottom",
  "iconSize",
  "suffixFontSize",
  "suffixFontMarginBottom",
  "suffixFontMarginLeft",
  "prefixFontSize",
  "prefixFontMarginBottom",
  "prefixFontMarginRight",
  "numberWidth",
  "tabMaxWidth",
  "tabMinWidth",
  "tabMaxHeight",
  "tabMinHeight",
  "anchorMaxWidth",
  "anchorMinWidth",
  "anchorMaxHeight",
  "anchorMinHeight",
  "activeTopNavBorderTopLeftRadius",
  "activeTopNavBorderTopRightRadius",
  "activeTopNavBorderBottomRightRadius",
  "activeTopNavBorderBottomLeftRadius",
  "liActiveBorderTopLeftRadius",
  "liActiveBorderTopRightRadius",
  "liActiveBorderBottomRightRadius",
  "liActiveBorderBottomLeftRadius",
  "liMaxWidthVal",
  "liMinWidthVal",
  "ulMarginTop",
  "divideWidth",
  "divideHeight",
    "dayBorderTopLeftRadius",
    "dayBorderTopRightRadius",
    "dayBorderBottomRightRadius",
    "dayBorderBottomLeftRadius",
    "todayLunarStyleFontSize",
    "activityLeft",
    "activityRight",
    "activityTop",
    "activityBottom",
  "titleActiveFontSize",
  "titleActiveLineHeight",
  "titleActiveLetterSpacing",
  "titleActiveBorderTopLeftRadius",
  "titleActiveBorderTopRightRadius",
  "titleActiveBorderBottomRightRadius",
  "titleActiveBorderBottomLeftRadius",
  "titleActiveBorderWidth",
  "titleHeight",
  "titleIconWidth",
  "titleActiveIconWidth",
  "titleIconMargin",
  "titleActiveIconMargin",
  "subFilterMaxWidthVal",
  "subFilterMinWidthVal",
  "subFilterMaxHeightVal",
  "subFilterMinHeightVal",
  "subFilterHeight",
  "subFilterBorderTopLeftRadius",
  "subFilterBorderTopRightRadius",
  "subFilterBorderBottomRightRadius",
  "subFilterBorderBottomLeftRadius",
  "filterBottomHeight",
  "labelBoxHeight",
  "labelHeight",
  "labelColumnMargin",
  "labelLineMargin",
  "labelBoxBorderTopLeftRadius",
  "labelBoxBorderTopRightRadius",
  "labelBoxBorderBottomRightRadius",
  "labelBoxBorderBottomLeftRadius",
  "labelBorderTopLeftRadius",
  "labelBorderTopRightRadius",
  "labelBorderBottomRightRadius",
  "labelBorderBottomLeftRadius",
  "labelWidth",
  "labelHeight",
  "labelFontSize",
  "labelLineHeight",
  "labelLetterSpacing",
  "activeIconWidth",
  "defaultIconWidth",
  "activeIconMargin",
  "defaultIconMargin",
  "labelIconWidth",
  "filterMargin",
  "labelIconMargin",
  "dayBorderTopLeftRadius",
  "dayBorderTopRightRadius",
  "dayBorderBottomRightRadius",
  "dayBorderBottomLeftRadius",
  "todayLunarStyleFontSize",
  "activityLeft",
  "activityRight",
  "activityTop",
  "activityBottom",
  "rowGap",
  "colGap",
  "columnGap",
  "emptyImgWidth",
  "emptyImgHeight",
  "hoverIconMargin",
  "hoverIconWidth",
  "backgroundFilter",
  "lineBorderWidth",
  //以下部分属性的类型可能为 0    【0,0,0,0】
  "borderWidth",
  "hoverBorderWidth",
  "hoverBoxShadowH",
  "hoverBoxShadowV",
  "hoverBoxShadowBlur",
  "hoverBoxShadowSpread",
  "activeBoxShadowH",
  "activeBoxShadowV",
  "activeBoxShadowBlur",
  "activeBoxShadowSpread",
  "activeBorderWidth",
  "topNavBorderWidth",
  "topNavBoxShadowH",
  "topNavBoxShadowV",
  "topNavBoxShadowBlur",
  "topNavBoxShadowSpread",
  "topNavPadding",
  "liHoverBorderWidth",
  "selectBoxShadowH",
  "selectBoxShadowV",
  "selectBoxShadowBlur",
  "selectBoxShadowSpread",
  "selectBorderWidth",
  "liBorderWidth",
  "liActiveBorderWidth",
  "pageTurnBorderWidth",
  "hoverPageTurnBorderWidth",
  "placeHolderFontSize",
  "thumbsHeight",
  "thumbsActiveBorderTopLeftRadius",
  "thumbsActiveBorderTopRightRadius",
  "thumbsActiveBorderBottomRightRadius",
  "thumbsActiveBorderBottomLeftRadius",
  "thumbsBorderWidth",
  "thumbsActiveBorderWidth",
  "thumbsBorderTopLeftRadius",
  "thumbsBorderTopRightRadius",
  "thumbsBorderBottomRightRadius",
  "thumbsBorderBottomLeftRadius",
  "thumbsBoxShadowH",
  "thumbsBoxShadowV",
  "thumbsBoxShadowBlur",
  "thumbsBoxShadowSpread",
  "thumbsActiveBoxShadowH",
  "thumbsActiveBoxShadowV",
  "thumbsActiveBoxShadowBlur",
  "thumbsActiveBoxShadowSpread",
  "thumbsPadding",
  "thumbsPaddingTop",
  "thumbsPaddingRight",
  "thumbsPaddingBottom",
  "thumbsPaddingLeft",
  "rectangleWidth",
  "rectangleHeight",
  "rectangleActiveWidth",
  "rectangleActiveHeight",
  "bulletsRadius",
  "paginationTop",
  "paginationBottom",
  "paginationLeft",
  "paginationRight",
  "fractionSize",
  "fractionFontSize",
  "fractionLineHeight",
  "fractionLetterSpacing",
  "slideWidth",
  "slideHeight",
  "slideBorderRadius",
  "buttonBoxShadowH",
  "buttonBoxShadowV",
  "buttonBoxShadowBlur",
  "buttonBoxShadowSpread",
  "borderRadius",
  "titleFontSize",
  "titleLineHeight",
  "titleLetterSpacing",
  "titlePadding",
  "titlePaddingTop",
  "titlePaddingRight",
  "titlePaddingBottom",
  "titlePaddingLeft",
  "weekFontSize",
  "lunarFontSize",
  "lunarHoverFontSize",
  "lunarActiveFontSize",
  "activeBorderTopLeftRadius",
  "activeBorderTopRightRadius",
  "activeBorderBottomRightRadius",
  "activeBorderBottomLeftRadius",
  "datePaddingTopVal",
  "datePaddingBottomVal",
  "todayStyleFontSize",
  "todayStyleBorderTopLeftRadius",
  "todayStyleBorderTopRightRadius",
  "todayStyleBorderBottomRightRadius",
  "todayStyleBorderBottomLeftRadius",
  "todayStyleBorderWidth",
  "activityWidth",
  "leftButtonIconX",
  "leftButtonIconY",
  "rightButtonIconX",
  "rightButtonIconY",
  "todayLegendFontSize",
  "todayLegendBorderWidth",
  "todayLegendBorderRadius",
  "todayLegendWidth",
  "todayLegendHeight",
  "activityLegendFontSize",
  "activityLegendBorderWidth",
  "activityLegendBorderRadius",
  "activityLegendWidth",
  "activityLegendHeight",
  "legendSpace",
  "legendPadding",
  "legendPaddingTop",
  "legendPaddingRight",
  "legendPaddingBottom",
  "legendPaddingLeft",
  "lineMargin",
  "columnMargin",
  "groupMargin",
  "defaultBorderRadius",
  "defaultBorderTopLeftRadius",
  "defaultBorderTopRightRadius",
  "defaultBorderBottomLeftRadius",
  "defaultBorderBottomRightRadius",
  "defaultBorderWidth",
  "defaultPadding",
  "defaultPaddingTop",
  "defaultPaddingRight",
  "defaultPaddingBottom",
  "defaultPaddingLeft",
  "itemPadding",
  "itemPaddingTop",
  "itemPaddingRight",
  "itemPaddingBottom",
  "itemPaddingLeft",
  "titleBorderRadius",
  "titleBorderTopLeftRadius",
  "titleBorderTopRightRadius",
  "titleBorderBottomLeftRadius",
  "titleBorderBottomRightRadius",
  "titleBorderWidth",
  "titleWidth",
  "activeLetterSpacing",
  "colMargin",
  "liPadding",
  "liPaddingTop",
  "liPaddingRight",
  "liPaddingBottom",
  "liPaddingLeft",
  "liActivePaddingTop",
  "liActivePaddingRight",
  "liActivePaddingBottom",
  "liActivePaddingLeft",
  "activeTopNavPaddingTop",
  "activeTopNavPaddingRight",
  "activeTopNavPaddingLeft",
  "activeTopNavPaddingBottom",
  "moreLineHeight",
  "moreLineHeight",
  "moreFontSize",
  "moreLineHeight",
  "moreFontSize",
  "moreLetterSpacing",
  "moreBorderTopLeftRadius",
  "moreBorderTopRightRadius",
  "moreBorderBottomRightRadius",
  "moreBorderBottomLeftRadius",
  "morePaddingTop",
  "morePaddingRight",
  "morePaddingBottom",
  "morePaddingLeft",
  "moreActiveLineHeight",
  "moreActiveFontSize",
  "moreActiveLetterSpacing",
  "moreActiveBorderTopLeftRadius",
  "moreActiveBorderTopRightRadius",
  "moreActiveBorderBottomRightRadius",
  "moreActiveBorderBottomLeftRadius",
  "moreActivePaddingTop",
  "moreActivePaddingRight",
  "moreActivePaddingBottom",
  "moreActivePaddingLeft",
  "moreIconWidth",
  "moreIconMargin",
  "rowColMargin",
  "rowColMarginRight",
  "selectOptionsHeight",
  "titlePadding2",
  "titlePaddingTop2",
  "titlePaddingRight2",
  "titlePaddingBottom2",
  "titlePaddingLeft2",
  "titleSelectFontSize",
  "titleSelectActiveFontSize",
  "activityBorderRadius",
  "activityTooltipWidth",
  "activityTooltipHeight",
  "activityLineHeight",
  "tooltipTitleFontSize",
  "tooltipTimeFontSize",
  "activityTooltipSpace",
  "tooltipBorderRadius",
  "tooltipBorderTopLeftRadius",
  "tooltipBorderTopRightRadius",
  "tooltipBorderBottomRightRadius",
  "tooltipBorderBottomLeftRadius",
  "tooltipBorderWidth",
  "tooltipPadding",
  "tooltipPaddingTop",
  "tooltipPaddingRight",
  "tooltipPaddingBottom",
  "tooltipPaddingLeft",
  "tooltipBoxShadowH",
  "tooltipBoxShadowV",
  "tooltipBoxShadowBlur",
  "tooltipBoxShadowSpread",
  "selectWidth",
  "topNavActiveBorderRadius",
  "topNavHoverBorderRadius",
  "liHoverBorderRadius",
  "liBorderRadius",
  "liPadding",
  "ulBorderRadius",
  "ulBoxShadowH",
  "ulBoxShadowV",
  "ulBoxShadowBlur",
  "ulBoxShadowSpread",
  "ulPadding",
  "hoverBorderRadius",
  "primaryBtnFontSize",
  "cancleBtnFontSize",
  "rangeInpFontSize",
  "primaryBtnBorderWidth",
  "cancleBtnBorderWidth",
  "activeBorderRadius",
  "activeTopNavBorderWidth",
  "activeTopNavBoxShadowH",
  "activeTopNavBoxShadowV",
  "activeTopNavBoxShadowBlur",
  "activeTopNavBoxShadowSpread",
  "liActiveBoxShadowH",
  "liActiveBoxShadowV",
  "liActiveBoxShadowBlur",
  "liActiveBoxShadowSpread",
  "dayBorderRadius",
  "subFilterBoxShadowH",
  "subFilterBoxShadowV",
  "subFilterBoxShadowBlur",
  "subFilterBoxShadowSpread",
  "subFilterPadding",
  "subFilterPaddingTop",
  "subFilterPaddingRight",
  "subFilterPaddingBottom",
  "subFilterPaddingLeft",
  "subFilterBorderWidth",
  "labelBoxBoxShadowH",
  "labelBoxBoxShadowV",
  "labelBoxBoxShadowBlur",
  "labelBoxBoxShadowSpread",
  "labelBoxShadowH",
  "labelBoxShadowV",
  "labelBoxShadowBlur",
  "labelBoxShadowSpread",
  "labelBoxPaddingTop",
  "labelBoxPaddingRight",
  "labelBoxPaddingBottom",
  "labelBoxPaddingLeft",
  "labelBoxBorderWidth",
  "labelPaddingTop",
  "labelPaddingRight",
  "labelPaddingBottom",
  "labelPaddingLeft",
  "labelBorderWidth",
  "dayBorderRadius",
  "textWidth",
  "textHeight",
  "textBorderBottomLeftRadius",
  "textBorderBottomRightRadius",
  "textBorderTopLeftRadius",
  "textBorderTopRightRadius",
  "textBorderRadius",
  "textPadding",
  "textPaddingBottom",
  "textPaddingLeft",
  "textPaddingRight",
  "textPaddingTop",
  "activeHeight",
  "preContentMargin"
]
// 需要进行px转换且为数组的的属性 例如 borderWidth:[1,2,3,4]
export const ARRAYPXRESEVERPROP = [
  "borderWidth",
  "boxShadowH",
  "boxShadowV",
  "boxShadowBlur",
  "boxShadowSpread",
  "liBoxShadowH",
  "liBoxShadowV",
  "liBoxShadowBlur",
  "liBoxShadowSpread",
  "hoverBorderWidth",
  "hoverBoxShadowH",
  "hoverBoxShadowV",
  "hoverBoxShadowBlur",
  "hoverBoxShadowSpread",
  "activeBoxShadowH",
  "activeBoxShadowV",
  "activeBoxShadowBlur",
  "activeBoxShadowSpread",
  "activeBorderWidth",
  "topNavBorderWidth",
  "topNavBoxShadowH",
  "topNavBoxShadowV",
  "topNavBoxShadowBlur",
  "topNavBoxShadowSpread",
  "topNavPadding",
  "liHoverBorderWidth",
  "selectBoxShadowH",
  "selectBoxShadowV",
  "selectBoxShadowBlur",
  "selectBoxShadowSpread",
  "selectBorderWidth",
  "liBorderWidth",
  "liActiveBorderWidth",
  "pageTurnBorderWidth",
  "hoverPageTurnBorderWidth",
  "padding",
  "thumbsBoxShadowH",
  "thumbsBoxShadowV",
  "thumbsBoxShadowBlur",
  "thumbsBoxShadowSpread",
  "thumbsActiveBoxShadowH",
  "thumbsActiveBoxShadowV",
  "thumbsActiveBoxShadowBlur",
  "thumbsActiveBoxShadowSpread",
  "buttonBoxShadowH",
  "buttonBoxShadowV",
  "buttonBoxShadowBlur",
  "buttonBoxShadowSpread",
  "borderRadius",
  "offset",
  "activeBorderRadius",
  "todayStyleBorderRadius",
  "defaultBoxShadowH",
  "defaultBoxShadowV",
  "defaultBoxShadowBlur",
  "defaultBoxShadowSpread",
  "titleBoxShadowH",
  "titleBoxShadowV",
  "titleBoxShadowBlur",
  "titleBoxShadowSpread",
  "allBorderWidth",
  "barBorderWidth",
  "activityBorderWidth",
  "colMargin",
  "liActivePadding",
  "activeTopNavPadding",
  "liPadding",
  "morePadding",
  "moreActivePadding",
  "moreBorderWidth",
  "moreActiveBorderWidth",
  "activityBorderRadius",
  "tooltipBorderRadius",
  "tooltipPadding",
  "topNavActiveBorderRadius",
  "topNavHoverBorderRadius",
  "liHoverBorderRadius",
  "liBorderRadius",
  "liPadding",
  "ulBorderRadius",
  "ulBoxShadowH",
  "ulBoxShadowV",
  "ulBoxShadowBlur",
  "ulBoxShadowSpread",
  "ulPadding",
  "hoverBorderRadius",
  "primaryBtnBorderWidth",
  "cancleBtnBorderWidth",
  "activeTopNavBorderWidth",
  "activeTopNavBoxShadowH",
  "activeTopNavBoxShadowV",
  "activeTopNavBoxShadowBlur",
  "activeTopNavBoxShadowSpread",
  "liActiveBoxShadowH",
  "liActiveBoxShadowV",
  "liActiveBoxShadowBlur",
  "liActiveBoxShadowSpread",
  "pxOffset",
  "defaultBorderWidth",
  "subFilterBoxShadowH",
  "subFilterBoxShadowV",
  "subFilterBoxShadowBlur",
  "subFilterBoxShadowSpread",
  "subFilterPadding",
  "subFilterPaddingTop",
  "subFilterPaddingRight",
  "subFilterPaddingBottom",
  "subFilterPaddingLeft",
  "subFilterBorderWidth",
  "labelBoxBoxShadowH",
  "labelBoxBoxShadowV",
  "labelBoxBoxShadowBlur",
  "labelBoxBoxShadowSpread",
  "labelBoxShadowH",
  "labelBoxShadowV",
  "labelBoxShadowBlur",
  "labelBoxShadowSpread",
  "labelBoxPaddingTop",
  "labelBoxPaddingRight",
  "labelBoxPaddingBottom",
  "labelBoxPaddingLeft",
  "labelBoxBorderWidth",
  "labelPaddingTop",
  "labelPaddingRight",
  "labelPaddingBottom",
  "labelPaddingLeft",
  "labelBorderWidth",
  "textBoxShadowBlur",
  "textBoxShadowH",
  "textBoxShadowSpread",
  "textBoxShadowV",
  "activePadding",
]
// 防抖
export const _debounce = (fn, t) => {
  let delay = t || 200
  let timer
  return function () {
    let args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      timer = null
      fn.apply(this, args)
    }, delay)
  }
}
export function getAllRectInNewLayout(pageLayoutList) {
  const res = []
  dfs(pageLayoutList)
  return res
  function dfs(node) {
    for (let i = 0; i < node.length; i++) {
      const start = res.length
      if (node[i]?.rectIds?.length) {
        res.push({
          rects: [...node[i].rectIds],
          size: { boundWidth: node[i].options.boundWidth, boundHeight: node[i].options.boundHeight },
          options: {
            bg: JSON.parse(JSON.stringify(node[i].options.bg || [])),
            tabRowStart: node[i].options.tabRowStart || false,
            tabColStart: node[i].options.tabColStart || false
          }
        })
      }
      if (node[i]?.layout?.rows?.length) {
        dfs(node[i].layout.rows)
      }
      if (node[i]?.layout?.cols?.length) {
        dfs(node[i].layout.cols)
      }
    }
  }
}
// 节流
export function _throttle(fn, interval) {
  let last
  let timer
  let _interval = interval || 200
  return function () {
    let th = this
    let args = arguments
    let now = +new Date()
    if (last && now - last < _interval) {
      clearTimeout(timer)
      timer = setTimeout(function () {
        last = now
        // console.log('c1');
        //最后一次点击的时间+设置的延时后执行下面函数
        // fn.apply(th, args);
      }, _interval)
    } else {
      last = now
      // console.log('c2');
      fn.apply(th, args)
    }
  }
}

const handleFindLayoutComponentBoxOptionsExec = (options, uid, res) => {
  let _rows = options
  if (res.key) return
  if (_rows) {
    for (let i = 0; i < _rows.length; i++) {
      if (res.key) return
      if (_rows[i] && _rows[i].cols) {
        let itemCols = _rows[i].cols
        for (let k = 0; k < itemCols.length; k++) {
          if (res.key) return
          if (itemCols[k].uid === uid) {
            res.key = JSON.parse(JSON.stringify(itemCols[k].componentBoxOptions))
            return
          } else {
            handleFindLayoutComponentBoxOptionsExec(itemCols[k].rows, uid, res)
          }
        }
      }
    }
  }
}
export const handleFindLayoutComponentBoxOptions = (options, uid) => {
  let res = {}
  handleFindLayoutComponentBoxOptionsExec(options, uid, res)
  return res.key
}
//布局组件内部组件cols的elementoptions查找函数
export const handleFindLayoutComponentOptions = (options, uid) => {
  let res = []
  findCol(options, uid)
  return res
  function findCol(options, uid) {
    let _rows = options
    if (_rows) {
      for (let i = 0; i < _rows.length; i++) {
        if (res?.length) break
        if (_rows[i] && _rows[i].cols) {
          let itemCols = _rows[i].cols
          for (let k = 0; k < itemCols.length; k++) {
            if (itemCols[k].uid === uid) {
              res = itemCols[k].elementOptions
              return
            } else {
              if (itemCols[k].rows && itemCols[k].rows.length) {
                findCol(itemCols[k].rows, uid)
              }
            }
          }
        }
      }
    }
  }

  // }
  // return result
}
export const handleFindLayoutComponentOptionsCols = (options, uid) => {
  const res = { value: undefined }
  handleFindLayoutComponentOptionsColsExec(options, uid, res)
  return res.value
}
// 布局画布中根据uid查找uid所在节点的父节点
export function handleFindLayoutStageOptionsByUid(options, uid, find) {
  for (let i = 0; i < options.length; i++) {
    const item = options[i]
    if (item.uid === uid) {
      find.data = options
      find.index = i
      return
    } else {
      let tempOptions = item.cols || item.rows
      if (tempOptions) {
        handleFindLayoutStageOptionsByUid(tempOptions, uid, find)
      }
    }
  }
  return
}
// 布局画布中根据uid查找uid所在节点的父节点
export function handleFindLayoutStageOptionsByContainerId(options, uid, find) {
  for (let i = 0; i < options.length; i++) {
    const item = options[i]
    if (item.container_id === uid) {
      find.data = options
      find.index = i
      return
    } else {
      let tempOptions = item.cols || item.rows
      if (tempOptions) {
        handleFindLayoutStageOptionsByContainerId(tempOptions, uid, find)
      }
    }
  }
}
//布局组件内部组件cols查找函数
export const handleFindLayoutComponentOptionsColsExec = (options, uid, res) => {
  let _rows = options
  if (_rows) {
    for (let i = 0; i < _rows.length; i++) {
      let rowsItem = _rows[i]
      if (rowsItem && rowsItem.cols) {
        let itemCols = rowsItem.cols
        let findCol = false
        for (let j = 0; j < itemCols.length; j++) {
          let colsItem = itemCols[j]
          if (colsItem.uid === uid) {
            findCol = true
            res.value = colsItem
            return
            // return colsItem
          } else {
            // if (colsItem.uid !== uid && colsItem.rows !== null) {
            if (itemCols[j].rows && itemCols[j].rows.length) {
              handleFindLayoutComponentOptionsColsExec(colsItem.rows, uid, res)
            }
          }
        }
        if (findCol) break
      } else {
        if (rowsItem.uid && rowsItem.uid === uid) {
          res.value = rowsItem
          return
        }
      }
    }
  }
}

//布局组件内部组件cols查找函数(查找当前选中元素的父级col)
export const handleFindLayoutComponentOptionsColsParentCols = (options, uid) => {
  const res = {
    value: null
  }
  handleFindLayoutComponentOptionsColsParentColsExec(options, uid, res)
  return res
}
const handleFindLayoutComponentOptionsColsParentColsExec = (options, uid, res) => {
  let _rows = options
  if (res.value) return
  if (_rows) {
    for (let i = 0; i < _rows.length; i++) {
      if (_rows[i] && _rows[i].cols) {
        let itemCols = _rows[i].cols
        for (let k = 0; k < itemCols.length; k++) {
          if (itemCols[k].uid === uid) {
            console.log("uu", uid)
            if (uid === "ea4be2a1-7208-11ed-94f6-55eaeace7216")
              res.value = {
                itemCols,
                index: k
              }
            return
          } else {
            handleFindLayoutComponentBoxOptionsExec(itemCols[k].rows, uid, res)
          }
        }
      }
    }
  }
}
//布局组件内部组件cols查找函数(查找当前选中元素的上一级col)
export const handleFindLayoutComponentOptionsColsParentRow = (colOptions, uid, uuid) => {
  let _rows = colOptions.rows
  let _outStatus = false
  let result = null
  if (_rows) {
    _rows.forEach((rowsItem, index) => {
      if (rowsItem && rowsItem.cols && !_outStatus) {
        let itemCols = rowsItem.cols
        itemCols.forEach(colsItem => {
          if (colsItem.uid === uid) {
            _outStatus = true
            result = { options: colOptions, row_id: index }
            window.localStorage.setItem(`${uid}${uuid}`, JSON.stringify(result))
            return result
          }
          if (colsItem.uid !== uid && colsItem.rows !== null) {
            handleFindLayoutComponentOptionsColsParentRow(colsItem, uid, uuid)
          }
        })
      } else return
    })
  }
  return result
}
/**
 *
 * @param {Object} options 需要进行递归的row
 * @param {Array} colsIdFromActiveRect 用来存放找到的uid的数组
 * @returns
 */
export function handleFindLayoutComponentUid(options, colsIdFromActiveRect) {
  let _rows = options
  let result = null
  if (_rows) {
    for (let i = 0; i < _rows.length; i++) {
      if (_rows[i] && _rows[i].cols && result === null) {
        let itemCols = _rows[i].cols
        for (let k = 0; k < itemCols.length; k++) {
          const foundUIds = colsIdFromActiveRect.some(item => itemCols[k].uid === item)
          if (!foundUIds && !itemCols[k].rows && !itemCols[k].cols && result === null) {
            colsIdFromActiveRect.push(itemCols[k].uid)
          } else {
            handleFindLayoutComponentUid(itemCols[k].rows, colsIdFromActiveRect)
          }
        }
      } else if (_rows[i] && _rows[i].uid && !colsIdFromActiveRect.some(item => _rows[i].uid === item)) return
    }
  }
  // }
  return result
}
/**
 *
 * @param {Object} options 需要进行递归的row
 * @param {Array} colsIdFromActiveRect 用来存放找到的uid的数组
 * @returns
 */
export function handleFindLayoutComponent(options, elementInCols) {
  let _rows = options
  let result = null
  if (_rows) {
    for (let i = 0; i < _rows.length; i++) {
      if (_rows[i] && _rows[i].cols && result === null) {
        let itemCols = _rows[i].cols
        for (let k = 0; k < itemCols.length; k++) {
          if (!elementInCols[itemCols[k].uid] && !itemCols[k].rows && !itemCols[k].cols && result === null) {
            elementInCols[itemCols[k].uid] = itemCols[k]
          } else {
            handleFindLayoutComponent(itemCols[k].rows, elementInCols)
          }
        }
      } else if (_rows[i] && _rows[i].uid && !elementInCols[_rows[i].uid]) return
    }
  }
  // }
  return result
}

/**
 * 返回当前所有col的uid
 * @param options
 * @param colsIds
 */
export function handleFindLayoutComponentAllUid(options, colsIds) {
  let _rows = options
  if (_rows) {
    for (let i = 0; i < _rows.length; i++) {
      if (_rows[i] && _rows[i].cols) {
        let itemCols = _rows[i].cols
        for (let k = 0; k < itemCols.length; k++) {
          if (!itemCols[k].rows) {
            colsIds.push(itemCols[k].uid)
          } else {
            handleFindLayoutComponentAllUid(itemCols[k].rows, colsIds)
          }
        }
      } else {
        return
      }
    }
  }
}
/**
 * 获取当前自由布局组件中tab || pagination组件的位置
 */
export function findTabs(rectAttr, ids, type) {
  let _titleOptions = rectAttr.titleOptions || rectAttr.options.titleOptions
  const res = { directionIndex: null, elementInLayoutId: null }
  if (_titleOptions) {
    for (let i = 0; i < _titleOptions.length; i++) {
      const _elementOptions = _titleOptions[i].elementOptions
      if (_elementOptions.length > 0) {
        for (let j = 0; j < _elementOptions.length; j++) {
          if (_elementOptions[j].type === type) {
            res.directionIndex = i
            res.elementInLayoutId = _elementOptions[j].elementInLayoutId
            return res
          }
        }
      }
    }
  }
  return res
}

/**
 * 通过自由布局中的组件是否包含某个插件名来找到该组件
 */
export function findComponentByPluginName(rectAttr, pluginName) {
  let _titleOptions = rectAttr.titleOptions || rectAttr.options.titleOptions
  const res = { directionIndex: null, elementInLayoutId: null }
  if (_titleOptions) {
    for (let i = 0; i < _titleOptions.length; i++) {
      const _elementOptions = _titleOptions[i].elementOptions
      if (_elementOptions.length > 0) {
        for (let j = 0; j < _elementOptions.length; j++) {
          if (
            _elementOptions[j].options.pluginName &&
            _elementOptions[j].options.pluginName.indexOf(pluginName) !== -1
          ) {
            res.directionIndex = i
            res.elementInLayoutId = _elementOptions[j].elementInLayoutId
            return res
          }
        }
      }
    }
  }
  return res
}

/**
 * 返回当前自由布局中titleOptions中的所有组件
 */
export function findAllComponentsInTitleOptions(rectAttr) {
  let _titleOptions = rectAttr.titleOptions || rectAttr.options.titleOptions
  let result = []
  if (_titleOptions) {
    for (let i = 0; i < _titleOptions.length; i++) {
      const _elementOptions = _titleOptions[i].elementOptions
      if (_elementOptions.length > 0) {
        for (let j = 0; j < _elementOptions.length; j++) {
          if (_elementOptions[j].type) {
            // 有type的才是业务组件
            const componentObj = {
              directionIndex: i,
              elementInLayoutId: _elementOptions[j].elementInLayoutId,
              type: _elementOptions[j].type
            }
            result.push(componentObj)
          }
        }
      }
    }
    return result
  }
}

/**
 * 找到当前通栏下的所有rectId集合
 * @param {*} layout
 * @returns
 */
export function findAllRects(layout) {
  const rectIds = []
  handleFindAllRects(layout, rectIds)
  return rectIds
}

/**
 *
 * @param {*} layout
 * @param {*} _rectIds
 */
function handleFindAllRects(layout, _rectIds) {
  let curLayout = layout
  let result = null
  if (curLayout) {
    if (curLayout.layout.rows && curLayout.layout.rows.length > 0 && result === null) {
      curLayout.layout.rows.forEach(item => {
        if (item.rectIds.length > 0) {
          for (let i in item.rectIds) {
            _rectIds.push(item.rectIds[i])
          }
        }
        handleFindAllRects(item, _rectIds)
      })
    } else if (curLayout.layout.cols && curLayout.layout.cols.length > 0 && result === null) {
      curLayout.layout.cols.forEach(item => {
        if (item.rectIds.length > 0) {
          for (let i in item.rectIds) {
            _rectIds.push(item.rectIds[i])
          }
        }
        handleFindAllRects(item, _rectIds)
      })
    } else return
  }
  return result
}

/**
 * 根据组件的rect_id找到当前组件所在通栏中的路径
 * @param root
 * @param rectId
 */
export function findCurrentComponentPathInLayoutByRectId(root, rectId) {
  let result = []
  const traverse = (data, rectId, path) => {
    if (data.layout.cols && data.layout.cols.length > 0) {
      for (let i = 0; i < data.layout.cols.length; i++) {
        path.push(i)
        const colsItem = data.layout.cols[i]
        if (colsItem.rectIds.includes(rectId)) {
          result = JSON.parse(JSON.stringify(path))
          return
        }
        traverse(colsItem, rectId, path)
        path.pop()
      }
    } else if (data.layout.rows && data.layout.rows.length > 0) {
      for (let j = 0; j < data.layout.rows.length; j++) {
        path.push(j)
        const rowsItem = data.layout.rows[j]
        if (rowsItem.rectIds.includes(rectId)) {
          result = JSON.parse(JSON.stringify(path))
          return
        }
        traverse(rowsItem, rectId, path)
        path.pop()
      }
    } else return
  }
  let flag = true // 只加一次当前通栏下标
  for (let i = 0; i < root.length; i++) {
    // 先判断模式，是新的画布模式，还是布局模式
    if (root[i].options.canvasOptions) {
      let rectsId = root[i].options.canvasOptions.rectsId
      let index = rectsId.indexOf(rectId)
      if (index > -1) {
        result.unshift(i)
        break
      }
    } else {
      traverse(root[i], rectId, [])
      if (result.length > 0 && flag) {
        flag = false
        result.unshift(i)
      }
    }
  }
  // console.log("result>>>", result)
  return result
}

/**
 *
 * @param layout
 * @param oldRectIds
 * @param newRectIds
 */
export function changeRectIds(layout, oldRectIds, newRectIds) {
  handleChangeRectId(layout, oldRectIds, newRectIds)
}
function handleChangeRectId(layout, oldRectIds, newRectIds) {
  let curLayout = layout
  let result = null
  if (curLayout) {
    if (curLayout.layout.rows && curLayout.layout.rows.length > 0 && result === null) {
      for (let i = 0; i < curLayout.layout.rows.length; i++) {
        const rowsItem = curLayout.layout.rows[i]
        for (let j = 0; j < rowsItem.rectIds.length; j++) {
          const rectId = rowsItem.rectIds[j]
          if (oldRectIds.includes(rectId)) {
            rowsItem.rectIds[j] = newRectIds[oldRectIds.indexOf(rectId)]
          }
        }
        handleChangeRectId(rowsItem, oldRectIds, newRectIds)
      }
    } else if (curLayout.layout.cols && curLayout.layout.cols.length > 0 && result === null) {
      for (let i = 0; i < curLayout.layout.cols.length; i++) {
        const colsItem = curLayout.layout.cols[i]
        for (let j = 0; j < colsItem.rectIds.length; j++) {
          const rectId = colsItem.rectIds[j]
          if (oldRectIds.includes(rectId)) {
            colsItem.rectIds[j] = newRectIds[oldRectIds.indexOf(rectId)]
          }
        }
        handleChangeRectId(colsItem, oldRectIds, newRectIds)
      }
    } else return
  }
  return result
}

/**
 * 通过组件类型获取组件名称
 * @param {*} type
 * @returns
 */
export function getValueByType(type) {
  return componentNames[type]
}
/**
 * 找出布局组件层级
 * @param options
 * @param rowData const rowData = { label: "row", id: 0, children: [] }
 * @returns {*}
 */
export function handleFindLayoutComponentsLevel(options, rowData, isReverse) {
  let _cols = options
  if (_cols) {
    for (let i = 0; i < _cols.length; i++) {
      rowData.children.push({ label: { value: "列", type: "col", id: i, uid: _cols[i].uid }, children: [] })
      if (!_cols[i].rows) {
        let itemElementOptions = _cols[i].elementOptions
        let elementOptionsPushed = []
        for (let g = 0; g < itemElementOptions.length; g++) {
          if (itemElementOptions[g].innerElement === "cxAutoLayout") {
            // 自由布局中嵌套自动布局的情况
            const autoLayoutResult = handleFindAutoLayoutComponentsLevel(itemElementOptions[g].elementOptions, {
              label: { value: "自动布局", type: "cxAutoLayout", id: g, path: itemElementOptions[g].path },
              children: []
            })
            rowData.children[i].children.push(autoLayoutResult)
          } else {
            elementOptionsPushed.push({
              label: {
                value: getValueByType(itemElementOptions[g].innerElement),
                type: itemElementOptions[g].innerElement,
                id: g,
                elementInLayoutId: itemElementOptions[g].elementInLayoutId || 0,
                uid: _cols[i].uid
              }
            })
          }
        }
        rowData.children[i].children = isReverse ? elementOptionsPushed.reverse() : elementOptionsPushed
      } else {
        let itemRows = _cols[i].rows
        for (let k = 0; k < itemRows.length; k++) {
          rowData.children[i].children.push({
            label: { value: "行", type: "row", id: k },
            children: []
          })
          if (itemRows[k].cols) {
            handleFindLayoutComponentsLevel(itemRows[k].cols, rowData.children[i].children[k], isReverse)
          }
        }
      }
    }
  }
  return rowData
}
/**
 * 找出布局组件中标题等其他组件的层级
 * @param options
 * @param titleData
 * @returns {*}
 */
export function handleFindLayoutTitlesLevel(options, titleData) {
  if (options) {
    for (let i = 0; i < options.length; i++) {
      titleData.children.push({ label: { value: options[i].type, type: "direction", id: i }, children: [] })
      let elements = options[i].elementOptions
      if (elements.length > 0) {
        for (let j = 0; j < elements.length; j++) {
          titleData.children[i].children.push({
            label: { value: elements[j].innerElement, type: elements[j].innerElement, id: j }
          })
        }
      }
    }
  }
  return titleData
}
/**
 * 找出自动布局组件层级
 * @param {*} options
 * @param {*} data
 * @returns {*}
 */
export function handleFindAutoLayoutComponentsLevel(options, data) {
  const elementOptions = options
  if (elementOptions) {
    for (let i = 0; i < elementOptions.length; i++) {
      if (elementOptions[i].innerElement !== "cxAutoLayout") {
        data.children.push({
          label: {
            value: getValueByType(elementOptions[i].innerElement),
            type: elementOptions[i].innerElement,
            id: elementOptions[i].elementInAutoLayoutId
          }
        })
      } else {
        data.children.push({
          label: {
            value: getValueByType(elementOptions[i].innerElement),
            type: elementOptions[i].innerElement,
            id: elementOptions[i].elementInAutoLayoutId,
            path: elementOptions[i].path
          },
          children: []
        })
        const _elementOptions = elementOptions[i].elementOptions
        handleFindAutoLayoutComponentsLevel(_elementOptions, data.children[i])
      }
    }
  }
  return data
}
//深度修改布局组件格式数据的uid
export function deepChangeUid(origin) {
  const res = {}
  const renderOrder = origin.options?.renderOrder || {}
  // 动画的uid先不处理，后面会统一处理
  const excludeProperties = ["controlIds", "passiveIds"]
  deepChange(origin, res)
  return res
  function deepChange(org, res) {
    if (org && typeof org === "object") {
      for (let k in org) {
        if (typeof org[k] === "object" && !excludeProperties.includes(k)) {
          deepChange(org[k], res)
        } else if (k === "uid") {
          const uid = res[org[k]] ?? uuid.v1()
          // 自由布局如果是排过序的，也需要统一替换
          Object.values(renderOrder).forEach(order => {
            const idx = order.indexOf(org[k])
            if (idx > -1) {
              order.splice(idx, 1, uid)
            }
          })
          res[org[k]] = uid
          org[k] = res[org[k]]
        }
      }
    }
  }
}
/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent("on" + event, handler)
      }
    }
  }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent("on" + event, handler)
      }
    }
  }
})()

export function getPageLayoutName(pageLayout) {
  let name = ""
  if (pageLayout.options.inDocument === "header") {
    name = "头部"
  } else if (pageLayout.options.inDocument === "relativeHeader") {
    name = "变换头部"
  } else if (pageLayout.options.inDocument === "footer") {
    name = "底部"
  } else if (pageLayout.options.inDocument === "anchor") {
    name = "锚点"
  } else if (pageLayout.options.inDocument === "popover") {
    name = "弹出框"
  } else if (pageLayout.options.inDocument === "drawer") {
    name = "抽屉"
  } else if (pageLayout.options.inDocument === "goTop") {
    name = "回到顶部"
  } else if (pageLayout.options.enableBayWindow) {
    name = "飘窗"
  } else {
    name = "通栏"
  }
  return name
}

/**
 * @description 数据加密 off(str, map)
 */
//TODO 临时处理，后续需要优化
export const encryption = (str, map, encType) => {
  APPIDLIST = [] // 每次保存前的时候初始化APPIDLIST
  appList = []
  let result = {}
  let _origin = typeof str === "string" ? JSON.parse(str) : str

  let clonePageLayout = []
  if(encType === 'save'){
    let pageLayoutList = _origin?.page?.pageLayoutList
    const isMoudlesEditing = location.href.indexOf("homeMoudles") > -1
    if(pageLayoutList && pageLayoutList.length > 0) {
      if (isMoudlesEditing && _origin.page.clonePageLayout) {
        clonePageLayout = _origin.page.clonePageLayout
      } else {
        pageLayoutList.forEach((pageLayout) => {
          let name = getPageLayoutName(pageLayout)
          let curPageLayout = {
            id: pageLayout.id,
            name: pageLayout.options.name || name,
            moudleStyleId: pageLayout.options.moudleStyleId || "",
            allRects: findAllRects(pageLayout),
            isShow: pageLayout.options.hasOwnProperty("isShow")  ? pageLayout.options.isShow :
                pageLayout.options.hasOwnProperty("enableBayWindow")? pageLayout.options.enableBayWindow : true
          }
          if(pageLayout && pageLayout.options){
            if (
              ((pageLayout.options.isFixed || ["absolute", "fixed"].includes(pageLayout.options.positionType)) &&
                !["header", "footer"].includes(pageLayout.options.inDocument)) ||
              !["header", "footer", "none", "relativeHeader"].includes(pageLayout.options.inDocument) ||
              pageLayout.options.enableBayWindow
            ) {
              // 特殊通栏，在列表里不能展示出来
              curPageLayout.disabled = true
            }
            if(pageLayout.options.inDocument !== 'none'){
              curPageLayout.layoutType = pageLayout.options.inDocument
            }
            clonePageLayout.push(curPageLayout)
          }
        })
      }
    }
  }
  result = deepClone(_origin, result, map, encType)
  let list = []
  if(encType === 'save'){
    clonePageLayout.forEach(pageLayout => {
      pageLayout.allRects.forEach(rectId=>{
        let curRect = appList.find(item=>item.rect_id === rectId)
        if(curRect){
          list.push({
            appId: curRect.appId,
            appName : curRect.appName
          })
        }
      })
    })
  }
  if (result.page) {
    result.page.appIdList = [...APPIDLIST]
    if(encType === 'save' && clonePageLayout.length === _origin?.page?.pageLayoutList.length){
      result.page.clonePageLayout = clonePageLayout
      result.page.appList = list
    }else{
      delete result.page.clonePageLayout
    }
  }

  if (result.page && result.page.subPages) {
    // 删除多余的subPage关系
    for (let k = 0; k < result.page.subPages.length; k++) {
      let _index = result.page.appIdList.findIndex(appId => result.page.subPages[k].i0 === appId || result.page.subPages[k].appId === appId)
      if (_index === -1) {
        result.page.subPages.splice(k, 1)
        k--
      }
    }
  }
  return JSON.stringify(result)
}
/**
 * @description 数据解密 off(str, map)
 */
export const decrypt = (str, map) => {
  let result = {}
  let tempMap = {}
  let _origin = JSON.parse(str)
  Object.keys(map).forEach(item => {
    tempMap[map[item]] = item
  })
  result = deepClone(_origin, result, tempMap)
  return result
}
// 多线程深拷贝
async function deepCloneWorker(origin, target, encType, APPIDLIST, rectId) {
  function deepClone(origin, target, encType, APPIDLIST,rectId) {
    //target是否存在如果不存在创建空对象
    let tar = target || {}
    for (let key in origin) {
      // 删除webJson中非组件上的appId
      // todo 先暂存一段时间，如果没有问题则直接 delete origin[key]
      // 图片，文本，按钮此时没有innerElement属性
      if((key === "myFetchParam" || key === 'appId')
            && !origin.hasOwnProperty("innerElement") && !origin.hasOwnProperty("moduleId")
            && !origin.hasOwnProperty("detailPageId") && !origin.hasOwnProperty("listPageId")) {
        if(key === "appId"){
          origin.oldAppId = origin[key]
        }
        if(key === "myFetchParam"){
          origin.oldMyFetchParam = origin[key]
        }
        delete origin[key]
        continue
      }
      if (key === "active") {
        // 清空所有组件的激活状态，保证自动保存的时候也被清除掉
        origin[key] = false
      }
      // 重置draggable属性值
      if (key === "draggable" && origin[key] === false && origin.draggableTemp) {
        origin[key] = true
      }
      // 将老的myFetchParam的appid 替换成新的 appId,解决后端统计的时候，统计到多个
      if (key === "myFetchParam" && origin.appId && origin.appId !== origin[key].appId) {
        origin[key].appOldId = origin[key].appId // 暂存，如果后续发现旧的这个appId无用，则删除
        origin[key].appId = origin.appId
      }
      //TODO 临时处理，后续需要优化
      if (encType === "collect") {
        if (key === "appId") continue
        if (key === "noCacheComponent") continue
        if (key === "moduleId") continue
        if (key === "restDataUrl") continue
        if (key === "myFetchParam") continue
        if (key === "typeId") continue
      }
      if (encType === "saveSystemModule") {
        if (key === "detailPageId") continue
        if (key === "detailPageTemplateEncId") continue
        if (key === "listPageId") continue
        if (key === "listPageTemplateEncId") continue
      }
      // 不在自由布局中，将同级的所有属性和默认属性进行差异化比较，进行增量保存
      if (key === "options") {
        let defaultOptions = null
        let innerElement = origin[key].innerElement
        switch (innerElement) {
          case "cxText":
            if (!origin[key].lineHeightType) {
              origin[key].lineHeightType = "px"
            }
            defaultOptions = text_children_temp
            break
          case "imageComponent":
            defaultOptions = image_children_temp
            break
          case "cxButton":
            defaultOptions = button_children_temp
            break
        }
        let diffOptions = {}
        if (!!defaultOptions) {
          const options = origin[key]
          Object.keys(options).forEach(item => {
            // 如果是对象或数组，需要进行深度比较
            // 如果是其他类型，直接比较
            const value = options[item]
            if (!defaultOptions.hasOwnProperty(item)) {
              diffOptions[item] = value
            } else {
              if (typeof value === "object" && value !== null) {
                if (JSON.stringify(value) !== JSON.stringify(defaultOptions[item])) {
                  diffOptions[item] = value
                }
              } else {
                if (value !== defaultOptions[item]) {
                  diffOptions[item] = value
                }
              }
            }
            /* 删除base64 */
            if ((item === "cover" || item === "menuIconClass") && value && value.indexOf("base64") > -1) {
              diffOptions[item] = ""
            }
            // 删除原属性
            delete options[item]
          })
          // 将差异化的属性放到origin的diffOptions属性中
          options["diffOptions"] = diffOptions
          options["innerElement"] = innerElement
        }
      }
      // 在自由布局中
      if (key === "elementOptions") {
        // origin[key]是数组
        const elementOptions = origin[key]
        elementOptions.forEach(options => {
          let defaultOptions = null
          let innerElement = options.innerElement
          switch (innerElement) {
            case "cxText":
              if (!options.lineHeightType) {
                options.lineHeightType = "px"
              }
              defaultOptions = text_children_temp
              break
            case "imageComponent":
              defaultOptions = image_children_temp
              break
            case "cxButton":
              defaultOptions = button_children_temp
              break
          }
          let diffOptions = {}
          if (!!defaultOptions && !options.hasOwnProperty("options")) {
            Object.keys(options).forEach(item => {
              // 如果是对象或数组，需要进行深度比较
              // 如果是其他类型，直接比较
              const value = options[item]
              if (!defaultOptions.hasOwnProperty(item)) {
                diffOptions[item] = value
              } else {
                if (typeof value === "object" && value !== null) {
                  if (JSON.stringify(value) !== JSON.stringify(defaultOptions[item])) {
                    diffOptions[item] = value
                  }
                } else {
                  if (value !== defaultOptions[item]) {
                    diffOptions[item] = value
                  }
                }
              }
              /* 删除base64 */
              if ((item === "cover" || item === "menuIconClass") && value && value.indexOf("base64") > -1) {
                diffOptions[item] = ""
              }
              // 删除原属性
              delete options[item]
            })
            options["diffOptions"] = diffOptions
            options["innerElement"] = innerElement
          }
        })
      }

      //当key=appId时，将appId的值单独取出来 只取组件内的appId
      // 自由布局里的组件appId会放到myFetchParam里和elementOptions下（头部导航）所以不能判断是否在options里
      // 排除掉文本和图片
      // 排除掉子页面关系

      if (
        origin.innerElement !== "imageComponent" &&
        origin.innerElement !== "cxText" &&
        origin.innerElement !== "cxEditor" &&
        key === "appId" &&
        origin[key] &&
        !(origin.hasOwnProperty("detailPageId") && origin.hasOwnProperty("listPageId")) &&
        !APPIDLIST.find(it => it === origin[key])
      ) {
        APPIDLIST.push(origin[key])
        console.log("appId",origin[key], origin)
        appList.push({
          appId: origin[key],
          appName : origin.menuName || origin.name,
          rect_id : rectId
        })
      }
      //剥离原型链的数据
      //判断是否为引用数据类型 对象或数组
      let curRectId = origin.hasOwnProperty("rect_id") &&  origin.hasOwnProperty("options")? origin.rect_id : rectId
      if (typeof origin[key] === "object" && origin[key] !== null) {
        if (Array.isArray(origin[key])) {
          tar[key] = []
          deepClone(origin[key], tar[key], encType, APPIDLIST,curRectId)
        }
        if (!Array.isArray(origin[key])) {
          tar[key] = {}
          deepClone(origin[key], tar[key], encType, APPIDLIST,curRectId)
        }
      } else {
        // appId还是存为i0，后端较多正则在查找
        if(data_dictionary_map_new[key]) {
          tar[data_dictionary_map_new[key]] = origin[key]
        } else if (key !== "thumbnail") {
          tar[key] = origin[key]
        }
      }
    }
    return tar
  }
  let curRectId = origin.hasOwnProperty("rect_id") &&  origin.hasOwnProperty("options")? origin.rect_id : rectId
  console.log("curRectId",curRectId)
  const data = deepClone(origin, target, encType, APPIDLIST, curRectId)
  console.log("appidlist", APPIDLIST)
  return [data, APPIDLIST]
}

//递归实现深拷贝
function deepClone(origin, target, tempMap, encType,rectId) {
  //target是否存在如果不存在创建空对象
  let tar = target || {}
  for (let key in origin) {
    // 删除webJson中非组件上的appId
    // 图片，文本，按钮此时没有innerElement属性
    if((key === "myFetchParam" || key === 'appId')
        && !origin.hasOwnProperty("innerElement") && !origin.hasOwnProperty("moduleId")
        && !origin.hasOwnProperty("detailPageId") && !origin.hasOwnProperty("listPageId")) {
      if(key === "appId"){
        origin.oldAppId = origin[key]
      }
       if(key === "myFetchParam"){
         origin.oldMyFetchParam = origin[key]
       }
       delete origin[key]
       continue
    }
    // 将老的myFetchParam的appid 替换成新的 appId,解决后端统计的时候，统计到多个
    if (key === "myFetchParam" && origin.appId && origin.appId !== origin[key].appId) {
      origin[key].appOldId = JSON.parse(JSON.stringify(origin[key])).appId // 暂存，如果后续发现旧的这个appId无用，则删除
      origin[key].appId = origin.appId
    }
    // 重置draggable属性值
    if (key === "draggable" && origin[key] === false && origin.draggableTemp) {
      origin[key] = true
    }
    //TODO 临时处理，后续需要优化
    if (encType === "collect") {
      if (key === "appId") continue
      if (key === "noCacheComponent") continue
      if (key === "moduleId") continue
      if (key === "restDataUrl") continue
      if (key === "myFetchParam") continue
      if (key === "typeId") continue
    }
    if (encType === "saveSystemModule") {
      if (key === "detailPageId") continue
      if (key === "detailPageTemplateEncId") continue
      if (key === "listPageId") continue
      if (key === "listPageTemplateEncId") continue
    }

    //  判断当前的组件类型
    if ((key === "c3" || key === "options") && origin[key].hasOwnProperty("diffOptions")) {
      // 说明当前递归到了组件的属性层
      let defaultOptions = null
      let innerElement = origin[key]["c4"] || origin[key]["innerElement"]
      switch (innerElement) {
        case "cxText":
          if (!origin[key].lineHeightType) {
            origin[key].lineHeightType = "px"
          }
          defaultOptions = text_children_temp
          break
        case "imageComponent":
          defaultOptions = image_children_temp
          break
        case "cxButton":
          defaultOptions = button_children_temp
          break
      }
      if (!!defaultOptions) {
        // 先将defaultOptions和diffOptions进行合并，再赋值给options
        let defaultOptionsTemp = JSON.parse(JSON.stringify(defaultOptions))
        let diffOptions = origin[key].diffOptions
        Object.assign(defaultOptionsTemp, diffOptions)
        origin[key] = defaultOptionsTemp
      }
    }

    // 在自由布局中
    if ((key === "f3" || key === "elementOptions") && origin[key].length > 0) {
      let diffOptionsList = []
      origin[key].forEach((item, index) => {
        if (item.hasOwnProperty("diffOptions")) {
          let defaultOptions = null
          let innerElement = item["c4"] || item["innerElement"]
          switch (innerElement) {
            case "cxText":
              if (!item.lineHeightType) {
                item.lineHeightType = "px"
              }
              defaultOptions = text_children_temp
              break
            case "imageComponent":
              defaultOptions = image_children_temp
              break
            case "cxButton":
              defaultOptions = button_children_temp
              break
          }
          if (!!defaultOptions) {
            let diffOptions = item.diffOptions
            let defaultOptionsTemp = JSON.parse(JSON.stringify(defaultOptions))
            Object.assign(defaultOptionsTemp, diffOptions)
            // 将差异化的属性放到origin的diffOptions属性中, 还需要保留innerElement属性
            diffOptionsList.push({
              index: index,
              defaultOptions: defaultOptionsTemp
            })
          }
        }
      })
      // 根据index进行赋值
      diffOptionsList.forEach(item => {
        origin[key][item.index] = item.defaultOptions
      })
    }

    //当key=appId时，将appId的值单独取出来 只取组件内的appId
    // 自由布局里的组件appId会放到myFetchParam里和elementOptions下（头部导航）所以不能判断是否在options里
    // if(key === "appId" && origin[key] && !APPIDLIST.find(it => it === origin[key])) {
    //     //   APPIDLIST.push(origin[key])
    //     // }
    // 上述方案可不删，下面这个方案可以筛掉子页面的脏数据对应关系
    if (
      origin.innerElement !== "imageComponent" &&
      origin.innerElement !== "cxText" &&
      origin.innerElement !== "cxEditor" &&
      key === "appId" &&
      origin[key] &&
      !(origin.hasOwnProperty("detailPageId") && origin.hasOwnProperty("listPageId")) &&
      !APPIDLIST.find(it => it === origin[key])
    ) {
      APPIDLIST.push(origin[key])
      appList.push({
        appId: origin[key],
        appName : origin.menuName || origin.name,
        rect_id: rectId
      })
    }
    // 针对自由布局，但是又有detailPageId和listPageId的脏数据, appId没有被加进appidlist的情况，再加一次
    if (key === "appId" && origin[key] && origin?.innerElement === "emptyLayoutComponent" && !APPIDLIST.find(it => it === origin[key])) {
      APPIDLIST.push(origin[key])
      appList.push({
        appId: origin[key],
        appName : origin.menuName || origin.name,
        rect_id: rectId
      })
    }
    //剥离原型链的数据
    //判断是否为引用数据类型 对象或数组
    if (typeof origin[key] === "object" && origin[key] !== null) {
      let _tempMapKey = null
      let status = true
      if (tempMap[key]) {
        _tempMapKey = tempMap[key]
        status = false
        if (Array.isArray(origin[key])) {
          tar[_tempMapKey] = []
        } else {
          tar[_tempMapKey] = {}
        }
      }
      let curRectId = origin.hasOwnProperty("rect_id") &&  origin.hasOwnProperty("options")? origin.rect_id : rectId
      if (Array.isArray(origin[key]) && status) {
        tar[key] = []
        deepClone(origin[key], tar[key], tempMap, encType,curRectId)
      }
      if (!Array.isArray(origin[key]) && status) {
        tar[key] = {}
        deepClone(origin[key], tar[key], tempMap, encType,curRectId)
      }
      if (!status) {
        deepClone(origin[key], tar[_tempMapKey], tempMap, encType,curRectId)
      }
    } else {
      let tempMapKey = null
      let status = true
      if (tempMap[key]) {
        tempMapKey = tempMap[key]
        status = false
        if (key !== "a8" && key !== "thumbnail") {
          tar[tempMapKey] = origin[key]
        }
        /* 删除base64 */
        if ((key === "cover" || key === "menuIconClass") && origin[key] && origin[key].indexOf("base64") > -1) {
          tar[key] = ""
        }
      }
      if (status) {
        if (key !== "a8" && key !== "thumbnail") {
          tar[key] = origin[key]
        }
        /* 删除base64 */
        if ((key === "cover" || key === "menuIconClass") && origin[key] && origin[key].indexOf("base64") > -1) {
          tar[key] = ""
        }
      }
    }
  }
  return tar
}

// 多线程加密, 避免cpu占用过高导致页面卡死
export async function encryptionWorker(str, encType) {
  APPIDLIST = [] // 每次保存前的时候初始化APPIDLIST
  appList = []
  let result = {}
  let _origin = typeof str === "string" ? JSON.parse(str) : str

  let clonePageLayout = []
  if(encType === 'save'){
    let pageLayoutList = _origin?.page?.pageLayoutList
    const isMoudlesEditing = location.href.indexOf("homeMoudles") > -1
    if (isMoudlesEditing && _origin.page.clonePageLayout) {
      clonePageLayout = _origin.page.clonePageLayout
    } else {
      pageLayoutList.forEach((pageLayout) => {
        let name = getPageLayoutName(pageLayout)
        let curPageLayout = {
          id: pageLayout.id,
          name: pageLayout.options.name || name,
          moudleStyleId: pageLayout.options.moudleStyleId || "",
          allRects: findAllRects(pageLayout),
          isShow: pageLayout.options.hasOwnProperty("isShow")  ? pageLayout.options.isShow :
              pageLayout.options.hasOwnProperty("enableBayWindow")? pageLayout.options.enableBayWindow : true
        }
        if(pageLayout && pageLayout.options){
          if (
            ((pageLayout.options.isFixed || ["absolute", "fixed"].includes(pageLayout.options.positionType)) &&
              !["header", "footer"].includes(pageLayout.options.inDocument)) ||
            !["header", "footer", "none", "relativeHeader"].includes(pageLayout.options.inDocument) ||
            pageLayout.options.enableBayWindow
          ) {
            // 特殊通栏，在列表里不能展示出来
            curPageLayout.disabled = true
          }
          if(pageLayout.options.inDocument !== 'none'){
            curPageLayout.layoutType = pageLayout.options.inDocument
          }
          clonePageLayout.push(curPageLayout)
        }
      })
    }
  }

  const [cloneResult, appIdList] = await deepCloneWorker(_origin, result, encType, APPIDLIST)
  result = cloneResult
  APPIDLIST = appIdList

  let list = []
  if(encType === 'save'){
    clonePageLayout.forEach(pageLayout => {
      pageLayout.allRects.forEach(rectId=>{
        let curRect = appList.find(item=>item.rect_id === rectId)
        if(curRect){
          list.push({
            appId: curRect.appId,
            appName : curRect.appName
          })
        }
      })
    })
  }
  if (result.page) {
    result.page.appIdList = [...APPIDLIST]
    if(encType === 'save' && clonePageLayout.length === _origin?.page?.pageLayoutList.length){
      result.page.clonePageLayout = clonePageLayout
      result.page.appList = list
    }else{
      delete result.page.clonePageLayout
    }
  }
  if (result.page && result.page.subPages) {
    // 删除多余的subPage关系
    for (let k = 0; k < result.page.subPages.length; k++) {
      let _index = result.page.appIdList.findIndex(appId => result.page.subPages[k]?.i0 === appId || result.page.subPages[k]?.appId === appId)
      if (_index === -1) {
        result.page.subPages.splice(k, 1)
        k--
      }
    }
  }
  result.encryptFlag = 1
  return JSON.stringify(result)
}

export function getRectAttribute(ids, env) {
  let _stage = null
  if (env) {
    _stage = env
  } else if (window.location.href.includes("appHome")) {
    _stage = "appStage"
  } else if (
    window.location.href.includes("bigScreen") ||
    window.location.href.includes("v2/p") ||
    window.isBigScreenPreviewUrl
  ) {
    _stage = "bigScreen"
  } else _stage = "stage"
  if (ids && this.$store) {
    if (ids.container_id === null || (ids.pageLayoutId !== null && typeof ids.pageLayoutId !== "undefined")) {
      return getAttrById(this.$store.state[_stage], ids, "pageLayout")
    }
    if (ids.rect_id !== null) {
      return getAttrById(this.$store.state[_stage], ids, "rect")
    } else {
      return getAttrById(this.$store.state[_stage], ids, "container")
    }
  } else return []
}
/**
 *
 * @param {object} stage 大屏/pc/app 三端的全量webjson
 * @param {*} _ids 需要获取配置项的组件的ids
 * @param {*} type 指定获取某个类型配置项，例如：rect,container,elementInLayout.....
 * @returns
 */
export function getAttrById(stage, _ids, type) {
  const ids = {
    container_id:
      typeof _ids.container_id !== "undefined"
        ? _ids.container_id
        : typeof _ids.containerID !== "undefined"
        ? _ids.containerID
        : _ids.containerId
  }
  //检查数据完整性
  const checkVal = val => typeof val !== "undefined" && val !== null
  if (checkVal(_ids.rect_id)) ids.rect_id = _ids.rect_id
  if (checkVal(_ids.rectId)) ids.rect_id = _ids.rectId
  if (checkVal(_ids.directionIndex)) ids.directionIndex = _ids.directionIndex
  if (checkVal(_ids.swiperContent_id)) ids.swiperContent_id = _ids.swiperContent_id
  if (checkVal(_ids.elementInSwiperId)) ids.elementInSwiperId = _ids.elementInSwiperId
  if (checkVal(_ids.elementInLayoutId)) ids.elementInLayoutId = _ids.elementInLayoutId
  if (checkVal(_ids.elementInAutoLayoutId)) ids.elementInAutoLayoutId = _ids.elementInAutoLayoutId
  if (checkVal(_ids.uid)) ids.uid = _ids.uid
  if (checkVal(_ids.pageId)) ids.pageId = _ids.pageId
  if (checkVal(_ids.pageLayoutId)) ids.pageLayoutId = _ids.pageLayoutId
  if (checkVal(_ids.activeIndex)) ids.activeIndex = _ids.activeIndex
  if (checkVal(_ids.elementInDataGridId)) ids.elementInDataGridId = _ids.elementInDataGridId
  if (checkVal(_ids.cellId)) ids.cellId = _ids.cellId
  if (_ids.path) {
    ids.path = _ids.path
  } else if (!_ids.path && _ids.elementOptions) {
    ids.path = _ids.elementOptions.options ? _ids.elementOptions.options.path : _ids.elementOptions.path
  }
  clearIds(ids)
  //返回rect的方式
  const rectReturn = () => {
    let rect = stage.page.children
      .find(it => it.container_id === ids.container_id && (ids.pageId ? it.pageId === ids.pageId : true))
      .children.find(it => it.rect_id === ids.rect_id)
    // if(rect?.options?.innerElement === 'cxPageLayoutComponent'){
    //   return rect.options.layout?.layout.rows[0]
    //   return rect.options.layout?.layout.rows[0]
    // }else{
    return rect
    // }
  }
  //返回页面布局通栏
  const pageLayoutReturn = () => {
    let indexArr = ids.pageLayoutId?.toString().split("_") || []
    // 先取得通栏
    let tempData = stage.page.pageLayoutList ? stage.page.pageLayoutList[indexArr[0]] : {}
    indexArr.splice(0, 1)
    if (indexArr.length === 0) {
      // 返回通栏
      return tempData
    }
    indexArr.forEach(item => {
      if (tempData?.layout?.rows?.length > 0) {
        tempData = tempData.layout.rows[item]
      } else if (tempData?.layout?.cols?.length > 0) {
        tempData = tempData.layout.cols[item]
      }
    })
    return tempData
  }
  // 返回通栏里的布局组件
  const pageLayoutComponentReturn = () => {
    // 先取得布局组件
    let tempData = stage.page.children
      .find(it => it.container_id === ids.container_id && (ids.pageId ? it.pageId === ids.pageId : true))
      .children.find(it => it.rect_id === ids.rect_id)
    ids.pageLayoutId = ids.pageLayoutId.toString().trim()
    const isShowTabs = tempData?.options?.layout?.options?.isShowTabs
    if (!isShowTabs && ids.pageLayoutId.length === 1) {// 长度为1时，获取的第一层通栏，不需要往下找布局 排除标签布局，会影响以前的功能
      tempData = tempData.options.layout
    } else {
      tempData = tempData.options.layout.layout.rows[0]
    }
    if (ids.pageLayoutId.length === 0) {
      return tempData
    }
    let indexArr = ids.pageLayoutId?.split("_") || []
    if (indexArr.length === 0) {
      return tempData
    }
    indexArr.splice(0, 2)
    indexArr.forEach(item => {
      if (tempData.layout.rows.length > 0) {
        tempData = tempData.layout.rows[item]
      } else if (tempData.layout.cols.length > 0) {
        tempData = tempData.layout.cols[item]
      }
    })
    console.log("tempData", JSON.parse(JSON.stringify(tempData)))
    return tempData
  }
  //返回通栏里的画布
  const layoutCanvasReturn = () => {
    let indexArr = ids.pageLayoutId?.toString().split("_") || []
    // 先取得通栏
    let tempData = stage.page.pageLayoutList ? stage.page.pageLayoutList[indexArr[0]] : {}
    return tempData
  }

  //返回container的方式
  const containerReturn = () => {
    return stage.page.children.find(
      it => it.container_id === (ids.container_id || 0) && (ids.pageId ? it.pageId === ids.pageId : true)
    )
  }
  //返回swiper中单个content的方式
  const SwiperContentReturn = () => {
    if (ids.elementInAutoLayoutId !== undefined) {
      let rect = elementInAutoLayoutReturn()
      return rect?.content.find(i => i.swiperContent_id === ids.swiperContent_id)
    }
    return stage.page.children
      .find(it => it.container_id === ids.container_id && (ids.pageId ? it.pageId === ids.pageId : true))
      .children.find(it => it.rect_id === ids.rect_id)
      .options.content.find(i => i.swiperContent_id === ids.swiperContent_id)
  }
  //返回swiper中单页content中的element的方式
  const elementInSwiperReturn = () => {
    if (ids.elementInAutoLayoutId !== undefined) {
      let rect = elementInAutoLayoutReturn()
      return rect.innerElement === "swiperComponent"
        ? rect?.content
            .find(i => i.swiperContent_id === ids.swiperContent_id)
            .elementOptions.find(i => i.elementInSwiperId === ids.elementInSwiperId)
        : rect
    }
    return stage.page.children
      .find(it => it.container_id === ids.container_id && (ids.pageId ? it.pageId === ids.pageId : true))
      .children.find(it => it.rect_id === ids.rect_id)
      .options.content.find(i => i.swiperContent_id === ids.swiperContent_id)
      .elementOptions.find(i => i.elementInSwiperId === ids.elementInSwiperId)
  }
  //返回layout中element的方式
  const elementInLayoutReturn = () => {
    const rect = stage.page.children
      .find(it => it.container_id === ids.container_id && (ids.pageId ? it.pageId === ids.pageId : true))
      .children.find(it => it.rect_id === ids.rect_id)
    if (!rect) {
      return false
    }
    const row_id = rect.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.options.activeIndex
    const tempRect = [rect.options.rows[row_id]]
    return (
      handleFindLayoutComponentOptions(tempRect, ids.uid).find(
        item => item.elementInLayoutId == ids.elementInLayoutId
      ) ||
      handleFindLayoutComponentOptions(
        rect.options.rows.slice(0, row_id).concat(rect.options.rows.slice(row_id + 1)),
        ids.uid
      ).find(item => item.elementInLayoutId == ids.elementInLayoutId)
    )
  }
  // 返回layout中的autoLayout的方式
  const autoLayoutInLayoutReturn = isFindParent => {
    let rect = stage.page.children
      .find(it => it.container_id === ids.container_id && (ids.pageId ? it.pageId === ids.pageId : true))
      .children.find(it => it.rect_id === ids.rect_id).options
    if (rect.innerElement === "cxAutoLayout" && ids.elementInAutoLayoutId !== undefined) {
      // 自由布局在自动布局中
      if (ids.hasOwnProperty("path")) {
        rect = handleFindElementInAutoLayout(rect, ids.path)?.elementOptions.find(
          it => it.elementInAutoLayoutId === ids.elementInAutoLayoutId
        ) // 查找自由布局
      } else {
        rect = rect.elementOptions.find(it => it.elementInAutoLayoutId === ids.elementInAutoLayoutId) // 查找自由布局
      }
    } else if (isExist(ids.elementInLayoutId) && isExist(ids.elementInAutoLayoutId)) {
      let rects = []
      for (let i = 0; i < rect.rows.length; i++) {
        rects = handleFindLayoutComponentOptions([rect.rows[i]], ids.uid)
        if (rects.length > 0) {
          break
        }
      }
      let autoRect = rects.find(item => item.elementInLayoutId == ids.elementInLayoutId)
      if (isFindParent) {
        let col
        return handleFindElementInAutoLayout(autoRect, ids.path, col)
      } else {
        return handleFindElementInAutoLayout(autoRect, ids.path)?.elementOptions.find(
          it => it.elementInAutoLayoutId === ids.elementInAutoLayoutId
        )
      }
    }
    let rects = []
    for (let i = 0; i < rect.rows.length; i++) {
      rects = handleFindLayoutComponentOptions([rect.rows[i]], ids.uid)
      if (rects.length > 0) {
        break
      }
    }
    return rects.find(item => item.elementInLayoutId == ids.elementInLayoutId)
  }

  // 返回元素所在自动布局
  const autoLayoutReturn = () => {
    let rect = stage.page.children
      .find(it => it.container_id === ids.container_id && (ids.pageId ? it.pageId === ids.pageId : true))
      .children.find(it => it.rect_id === ids.rect_id)
    if (ids.uid && ids.elementInLayoutId !== undefined) {
      // 注意会返回自由布局中的元素！！！
      return autoLayoutInLayoutReturn(true)
    }
    return handleFindElementInAutoLayout(rect, ids.path)
  }
  //返回autoLayout中element的方式
  const elementInAutoLayoutReturn = () => {
    if (ids.uid && ids.elementInLayoutId !== undefined && ids.elementInLayoutId !== null) {
      // 注意会返回自由布局中的元素！！！
      return autoLayoutInLayoutReturn()
    }
    return autoLayoutReturn()?.elementOptions?.find(it => it.elementInAutoLayoutId === ids.elementInAutoLayoutId)
  }
  const elementInTitleOptionsReturn = () => {
    let rect = rectReturn()?.options
    if (ids.elementInAutoLayoutId !== null && typeof ids.elementInAutoLayoutId !== "undefined") {
      rect = elementInAutoLayoutReturn()
    }
    return rect?.titleOptions[ids.directionIndex].elementOptions.find(
      it => it.elementInLayoutId === ids.elementInLayoutId
    )
  }
  const dataGridReturn = () => {
    let rect = rectReturn()?.options
    // 判断当前组件是否在自动布局中
    if (isExist(ids.elementInAutoLayoutId)) {
      // 判断当前元素是否在自动布局中
      rect = elementInAutoLayoutReturn()
    }
    return rect
  }
  const dataGridCellReturn = () => {
    let rect = rectReturn()?.options
    // 判断当前组件是否在自动布局中
    if (isExist(ids.elementInAutoLayoutId)) {
      // 判断当前元素是否在自动布局中
      rect = elementInAutoLayoutReturn()
    }
    if (rect && rect.cells) {
      return rect.cells.find(it => it.cellId === ids.cellId)
    }
  }
  const elementInDataGridReturn = () => {
    let rect = dataGridCellReturn()
    if (rect && ids.elementInDataGridId !== null && typeof ids.elementInDataGridId !== "undefined") {
      return rect.elementOptions.find(it => it.elementInDataGridId === ids.elementInDataGridId)
    }
  }

  if (type) {
    if (type === "pageLayout") {
      if (ids.rect_id !== null && typeof ids.rect_id !== "undefined") {
        return pageLayoutComponentReturn()
      } else {
        return pageLayoutReturn()
      }
    }
    if (type === "rect") return rectReturn()
    if (type === "container") return containerReturn()
    if (type === "swiperContent") return SwiperContentReturn()
    if (type === "elementInSwiper") return elementInSwiperReturn()
    if (type === "elementInLayout") return elementInLayoutReturn()
    if (type === "elementInLayoutOriginalData") return autoLayoutInLayoutReturn() // 查找自由布局中的自动布局
    if (type === "elementInAutoLayout") return elementInAutoLayoutReturn() // 查找自动布局中的元素
    if (type === "autoLayout") return autoLayoutReturn() // 查找当前元素所在的自动布局
    if (type === "layoutCanvas") return layoutCanvasReturn() // 查找通栏里的画布
    if (type === "pageLayoutComponent") return pageLayoutComponentReturn() // 查找通栏里的布局组件
    if (type === "autoLayoutInLayout") {
      // 查找自由布局中的自动布局下的元素
      let layoutRect = autoLayoutInLayoutReturn() // 查找自由布局中自动布局
      if (ids.elementInAutoLayoutId === null || typeof ids.elementInAutoLayoutId === "undefined") {
        return layoutRect
      }
      return handleFindElementInAutoLayout(layoutRect, ids.path) // 返回当前元素所在的自动布局
    }
    if (type === "elementInTitleOptions") return elementInTitleOptionsReturn()
    if (type === "elementInDataGrid") return elementInDataGridReturn()
    if (type === "dataGridCell") return dataGridCellReturn()
    if (type === "dataGrid") return dataGridReturn()
  }
  //  未传type的情况，后期尽量不传type
  let idsLen = Object.keys(ids).length
  if (ids.hasOwnProperty("pageId")) {
    // 大屏情况下包含了pageId
    idsLen--
  }
  if (ids.hasOwnProperty("path") && !ids.hasOwnProperty("elementInAutoLayoutId")) {
    // 使用图层的情况
    idsLen--
  }
  if (idsLen === 1) {
    if (checkVal(ids.pageLayoutId)) {
      // 通栏的情况
      return pageLayoutReturn()
    } else if (checkVal(ids.container_id)) {
      // 画布的情况
      return containerReturn()
    }
  }
  // 常规组件
  if (idsLen === 2) {
    if (checkVal(ids.container_id) && checkVal(ids.pageLayoutId)) {
      // 通栏的情况
      return pageLayoutReturn()
    } else if (ids.hasOwnProperty("container_id") && ids.hasOwnProperty("rect_id")) {
      // 常规组件的情况
      return rectReturn()
    }
  }
  // 接下来的情况都有container_id 和 rect_id
  if (ids.hasOwnProperty("container_id") && ids.hasOwnProperty("rect_id")) {
    if (ids.hasOwnProperty("elementInAutoLayoutId")) {
      //  有问题，待细化
      if(ids.hasOwnProperty("cellId") && ids.hasOwnProperty("elementInDataGridId")){
        return elementInDataGridReturn()
      } else if(ids.hasOwnProperty("cellId") ){
        return dataGridCellReturn()
      }
      return elementInAutoLayoutReturn()
    }
    if (idsLen === 3) {
      if (ids.uid) {
        // 单元格  通过拿自由布局属性解析
        // 兼容旧模式，拿自由布局
        return rectReturn()
      } else if (ids.hasOwnProperty("swiperContent_id")) {
        // 轮播的 单元格
        return SwiperContentReturn()
      } else if (ids.hasOwnProperty("pageLayoutId")) {
        // 标签布局组件内的布局（栅格模式下）
        return pageLayoutComponentReturn()
      } else if (ids.hasOwnProperty("directionIndex")) {
        // 自由布局内的边栏 目前没有单独取自由布局边栏的情况
        // 通过拿自由布局属性解析
      } else if (ids.hasOwnProperty("cellId")) {
        // 数据列表
        return dataGridCellReturn()
      }
    } else if (idsLen === 4) {
      if (ids.hasOwnProperty("elementInLayoutId") && ids.hasOwnProperty("directionIndex")) {
        // 边栏内的基础组件
        return elementInTitleOptionsReturn()
      } else if (ids.hasOwnProperty("elementInLayoutId") && ids.hasOwnProperty("uid")) {
        // 自由布局内的基础组件
        return elementInLayoutReturn()
      } else if (ids.hasOwnProperty("swiperContent_id") && ids.hasOwnProperty("elementInSwiperId")) {
        // 轮播内的基础组件
        return elementInSwiperReturn()
      } else if (ids.hasOwnProperty("elementInAutoLayoutId") && ids.hasOwnProperty("path")) {
        return elementInAutoLayoutReturn()
      } else if (ids.hasOwnProperty("elementInDataGridId") && ids.hasOwnProperty("cellId")) {
        // 数据列表
        return elementInDataGridReturn()
      }
    }
  }

  // if (type) {
  //   if (type === "pageLayout") {
  //     if(ids.rect_id !== null && typeof ids.rect_id !=='undefined'){
  //       return pageLayoutComponentReturn()
  //     }else{
  //       return pageLayoutReturn()
  //     }
  //   }
  //   if (type === "rect") return rectReturn()
  //   if (type === "container") return containerReturn()
  //   if (type === "swiperContent") return SwiperContentReturn()
  //   if (type === "elementInSwiper") return elementInSwiperReturn()
  //   if (type === "elementInLayout") return elementInLayoutReturn()
  //   if (type === "elementInLayoutOriginalData") return autoLayoutInLayoutReturn() // 查找自由布局中的自动布局
  //   if (type === "elementInAutoLayout") return elementInAutoLayoutReturn() // 查找自动布局中的元素
  //   if (type === "autoLayout") return autoLayoutReturn() // 查找当前元素所在的自动布局
  //   if (type === "layoutCanvas") return layoutCanvasReturn() // 查找通栏里的画布
  //   if (type === "pageLayoutComponent") return pageLayoutComponentReturn() // 查找通栏里的布局组件
  //   if (type === "autoLayoutInLayout") { // 查找自由布局中的自动布局下的元素
  //     let layoutRect = autoLayoutInLayoutReturn() // 查找自由布局中自动布局
  //     if (ids.elementInAutoLayoutId === null || typeof ids.elementInAutoLayoutId === "undefined") {
  //       return layoutRect
  //     }
  //     return handleFindElementInAutoLayout(layoutRect, ids.path) // 返回当前元素所在的自动布局
  //   }
  //   if (type === "elementInTitleOptions") return elementInTitleOptionsReturn()
  // } else if (checkVal(ids.elementInAutoLayoutId)) {
  //   return elementInAutoLayoutReturn()
  // } else if (checkVal(ids.elementInSwiperId)) {
  //   return elementInSwiperReturn()
  // } else if (checkVal(ids.directionIndex)) {
  //   return elementInTitleOptionsReturn()
  // } else if (checkVal(ids.elementInLayoutId)) {
  //   return elementInLayoutReturn()
  // } else if (checkVal(ids.swiperContent_id)) {
  //   return SwiperContentReturn()
  // } else if (checkVal(ids.pageLayoutId)) {
  //   if(ids.rect_id !== null && typeof ids.rect_id !=='undefined'){
  //     return pageLayoutComponentReturn()
  //   }else{
  //     return pageLayoutReturn()
  //   }
  // } else if (checkVal(ids.rect_id)) {
  //   if(checkVal(ids.pageLayoutId)){
  //     // 返回布局组件里的布局
  //     return pageLayoutComponentReturn()
  //   }else{
  //     return rectReturn()
  //   }
  // } else if (checkVal(ids.container_id)) {
  //   return containerReturn()
  // }
}
// 查找在自动布局组件中的元素
function handleFindElementInAutoLayout(tempRect, path) {
  let tempPath = path
  if (!path) {
    return tempRect && tempRect.options ? tempRect.options : tempRect
  }
  tempPath = JSON.parse(JSON.stringify(path))
  if (Array.isArray(path) && path.length === 0) {
    return tempRect.options ? tempRect.options : tempRect
  }
  let tempElementOptions = tempRect.options ? tempRect.options.elementOptions : tempRect.elementOptions
  for (let i = 0; i < tempElementOptions.length; i++) {
    if (tempElementOptions[i].elementInAutoLayoutId === tempPath[0]) {
      tempPath.shift()
      if (tempPath.length === 0) {
        return tempElementOptions[i].options ? tempElementOptions[i].options : tempElementOptions[i]
      } else {
        return handleFindElementInAutoLayout(tempElementOptions[i], tempPath)
      }
    }
  }
}
//递归实现
//@leafId  查找的id，
//@nodes   原始Json数据
//@path    供递归使用
export function findPathByLeafId(leafId, nodes, path) {
  if (path === undefined) {
    path = {}
  }
  let newNodes = nodes.cols
  for (var i = 0; i < newNodes.length; i++) {
    var tmpPath = path
    if (leafId == newNodes[i].uid) {
      tmpPath = newNodes[i]
      return tmpPath
    }
    if (newNodes[i].rows) {
      for (let j = 0; j < newNodes[i].rows.length; j++) {
        var findResult = findPathByLeafId(leafId, newNodes[i].rows[j], tmpPath)
        if (findResult) {
          // console.log(findResult)
          return findResult
        }
      }
    }
  }
}
export function getTreeAttrById(stage, _ids, type) {
  const ids = {
    container_id:
      typeof _ids.container_id !== "undefined"
        ? _ids.container_id
        : typeof _ids.containerID !== "undefined"
        ? _ids.containerID
        : _ids.containerId,
    rect_id:
      typeof _ids.rect_id !== "undefined"
        ? _ids.rect_id
        : typeof _ids.rectId !== "undefined"
        ? _ids.rectId
        : _ids.rectID
  }
  if (type) {
    if (type === "rect") {
      return stage.treeData[0].children
        .find(it => it.id === ids.container_id)
        .children.find(it => it.id === ids.rect_id)
    }
    if (type === "container") {
      return stage.treeData[0].children.find(it => it.id === ids.container_id)
    }
  }
  if (typeof ids.rect_id !== "undefined") {
    return stage.treeData[0].children.find(it => it.id === ids.container_id).children.find(it => it.id === ids.rect_id)
  } else {
    return stage.treeData[0].children.find(it => it.id === ids.container_id)
  }
}

//图片大小验证  fileMaxSize 单位
export function verificationPicFile(file, fileMaxSize) {
  var fileSize = file.size
  var size = fileSize / 1024
  if (size > fileMaxSize * 1024) {
    file.value = ""
    return false
  } else {
    return true
  }
}

// 图片上传
export async function uploadResources(file, maxSize, $this, callback) {
  var reader = new FileReader()
  var fileName = file.name
  maxSize = maxSize || 5 // 默认不传值的时候 为5M
  var isOverSize = verificationPicFile(file, maxSize)
  if (!isOverSize) {
    this.$message({
      customClass: "bigScreen_msg_backGroud",
      duration: 3000,
      message: `图片大小不能超过${maxSize}M`
    })
    return
  }
  reader.onloadend = function (e) {
    // 文件加载完处理
    var base64 = e.target.result
    $this
      .instance({
        method: "post",
        url: `usts/base64?uploadFileName=${fileName}`,
        headers: { "Content-Type": "application/json;charset=utf-8" },
        data: base64
      })
      .then(res => {
        if (res.data.code === 1) {
          if (callback && typeof callback == "function") {
            callback(res.data.data.url)
          }
        }
      })
  }
  reader.readAsDataURL(file)
}
/**
 *
 * @param {Object} options 需要用来递归查找可用cols的对象
 * @returns
 */
export function getAllColsUidInLayoutComponent(options) {
  const _colsIdFromActiveRect = []
  handleFindLayoutComponentUid(options, _colsIdFromActiveRect)
  return _colsIdFromActiveRect
}
/**
 * //返回一条路径，该路径为 在传入的row中找到该uid的最短路径
 * @param {Object} row
 * @param {String} uid
 * @returns
 */
export function findColPathByUid(row, uid) {
  let res = null
  dfs(Array.isArray(row) ? row : [row], uid)
  return res
  function dfs(rows, uid, path = []) {
    if (res !== null) return
    for (let i = 0; i < rows.length; i++) {
      if (rows[i]?.cols?.length) {
        for (let j = 0; j < rows[i].cols.length; j++) {
          const currPath = path.concat({
            rows: rows,
            rowId: i,
            cols: rows[i].cols,
            colId: j
          })
          if (rows[i].cols[j].uid === uid) {
            res = currPath
            return
          } else if (res === null && rows[i].cols[j].rows) {
            dfs(rows[i].cols[j].rows, uid, currPath)
          }
        }
      }
    }
  }
}
/**
 *
 * @param {Object} options 需要用来递归查找可用cols内的组件
 * @returns {Object}
 */
export function getAllElementsInColsInLayoutComponent(options) {
  const elementInCols = {}
  handleFindLayoutComponent(options, elementInCols)
  return elementInCols
}

// 判断当前的页面是不是预览页面
export function isSsrPage() {
  let href = window.location.href
  if (href.indexOf("w") > -1) {
    return false
  }
  return true
}
// 判断当前的页面是不是bigscreen预览页面
export function isBigScreenPreview() {
  let href = window.location.href
  if (href.indexOf("bigScreenPreview") > -1 || href.indexOf("v2/p") > -1 || window.isBigScreenPreviewUrl) {
    return true
  }
  return false
}
function iA(arr) {
  return Array.isArray(arr)
}
function iN(num) {
  return isNaN(num)
}
export function checkVal(val, key) {
  if (typeof val === "undefined" || val === null) return undefined
  //键名是数字,说明是在获取数组数据
  if (!iN(key) && iA(val)) {
    return val[key]
  } else {
    //获取对象数据
    return val[key] !== undefined ? val[key] : undefined
  }
}
export function hasProperty(org, name) {
  if (!org) return false
  const nameArr = name.split(".")
  let tempVal = null
  let res = null
  return nameArr.every((keyName, index) => {
    if (index) {
      tempVal = checkVal(tempVal, keyName)
    } else {
      tempVal = checkVal(org, keyName)
    }
    if (tempVal === null || tempVal === undefined || tempVal !== tempVal) {
      return false
    } else {
      res = tempVal
      return true
    }
  })
    ? res
    : undefined
}
//判断并设置默认值，如果有这个属性就直接返回这个属性，如果没有，就设置一个传入的默认值并且返回默认值
/**
 *
 * @param {object} org 所需返回的属性所在的对象
 * @param {string} key 所需返回属性的属性名
 * @param {string} dataName //当前数据在当前组件的computed中的属性名
 * @param {any} primaryValue //默认值
 * @returns
 */
export function checkAndSetPrimaryVal(org, key, dataName, primaryValue) {
  const check = hasProperty(org, key)
  if (typeof check === "undefined") {
    historyIgnoreWrap(() => {
      this[dataName] = primaryValue
    })()
    return primaryValue
  } else {
    return check
  }
}
export function checkType(val) {
  return typeof val !== "undefined"
}
export function copyToClip(content) {
  var ele = document.createElement("input") //创建一个input标签
  ele.setAttribute("value", content) // 设置改input的value值
  document.body.appendChild(ele) // 将input添加到body
  ele.select() // 获取input的文本内容
  document.execCommand("copy") // 执行copy指令
  document.body.removeChild(ele) // 删除input标签
  return Promise.resolve(1)
}
export function cached(fn) {
  const cache = Object.create(null)
  return function cachedFn(str) {
    const fnKey = `${fn.name}_${str}`.trim()
    const hit = cache[fnKey]
    return hit || (cache[fnKey] = fn(str))
  }
}

const arrayFrom = len => {
  const loopArr = new Array(len).join(",").split(",")
  return loopArr
}
export const arrayFromCache = cached(arrayFrom)

export const getHeight = el => {
  let height = 0
  if (el.getBoundingClientRect) {
    height = el.getBoundingClientRect().height
  }
  if (!height) {
    height = Math.max(el.offsetHeight, el.clientHeight)
  }

  return height
}

/* eslint-disable */
const supportCss3 = style => {
  let prefix = ["webkit", "Moz", "ms", "o"],
    i,
    humpString = [],
    htmlStyle = document.documentElement.style,
    _toHumb = function (string) {
      return string.replace(/-(\w)/g, ($0, $1) => $1.toUpperCase())
    }

  for (i in prefix) {
    humpString.push(_toHumb(`${prefix[i]}-${style}`))
  }

  humpString.push(_toHumb(style))

  for (i in humpString) {
    if (humpString[i] in htmlStyle) return prefix[i] || true
  }

  return false
}
export const supportCssCache = cached(supportCss3)
/* eslint-enable */

export const callExp = (main, exp) => {
  const layerList = exp.split(".").filter(Boolean)
  let value = null
  try {
    if (layerList.length) {
      value = layerList.reduce((prev, next) => prev[next], main)
    }
  } catch (ex) {
    value = null
  }
  return value
}

export const easeToCubicMap = {
  "Cubic.easeInOut": "cubic-bezier(0.65, 0.05, 0.36, 1)",
  "Cubic.easeIn": "cubic-bezier(0.55, 0.06, 0.68, 0.19)",
  "Cubic.easeOut": "cubic-bezier(0.22, 0.61, 0.36, 1)",
  "Quad.easeIn": "cubic-bezier(0.55, 0.09, 0.68, 0.53)",
  "Quad.easeOut": "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  "Quad.easeInOut": "cubic-bezier(0.46, 0.03, 0.52, 0.96)",
  Linear: "linear"
}
class AsyncTaskPool {
  constructor(max) {
    this.max = max
    this.count = 0
    this.taskQueue = [] //总的等待执行队列
    //all-request的promise状态，有三种状态:1.'WAIT': 还未初始化promise。2.pending:请求等待中。3.promise返回。4.null请求过期
    this.allReqPromiseHandle = null
    this.waitQueue = [] //allReqPromiseHandle在WAIT状态时的等待执行的promise
  }
  add(axios) {
    const fn = () => axios
    this.count = this.count + 1
    if (this.count - this.taskQueue.length > this.max) {
      //任务超了 等待执行
      return new Promise((reslove, reject) => {
        this.taskQueue.push([fn, [reslove, reject]])
      })
    } else {
      return this.exec(fn)
    }
  }
  checkAppId(appId) {
    return new Promise((resolve, reject) => {
      if (this.allReqPromiseHandle === "WAIT") {
        this.waitQueue.push({ appId, resolve, reject })
      } else if (this.allReqPromiseHandle) {
        this.allReqPromiseHandle
          .then(res => {
            if (res.data.data[appId]) {
              resolve(res.data.data[appId])
            } else reject(appId + " is undefined") //allRequest里没这个appid的数据
          })
          .catch(err => reject("all-request error")) //allRequest请求报错
      } else reject("all-req has expire") //allRequest过期了
    })
  }

  initAllReq(axiosExec) {
    this.allReqPromiseHandle = axiosExec
    this.allReqPromiseHandle
      .then(res => {
        while (this.waitQueue.length) {
          try {
            const { appId, resolve, reject } = this.waitQueue.shift()
            if (appId && resolve && reject) {
              if (res[appId]) resolve(res.data.data[appId])
              else reject(appId + " is undefined")
            }
          } catch (error) {
            console.log(error)
          }
        }
        for (let i = 0; i < this.waitQueue.length; i++) {}
      })
      .finally(done => {
        setTimeout(() => {
          this.allReqPromiseHandle = null
        }, 1000 * 10) //保质期
      })
  }
  exec(fn, re) {
    return new Promise((resolve, reject) => {
      fn()
        .then(res => {
          this.count = this.count ? this.count - 1 : 0
          if (this.taskQueue.length && this.count - this.taskQueue.length < this.max) {
            const task = this.taskQueue.shift()
            this.exec(task[0], task[1])
          }
          re ? re[0](res) : resolve(res)
        })
        .catch(err => {
          this.count = this.count ? this.count - 1 : 0
          if (this.taskQueue.length && this.count - this.taskQueue.length < this.max) {
            const task = this.taskQueue.shift()
            this.exec(task[0], task[1])
          }
          re ? re[1](err) : reject(err)
        })
    })
  }
}
export const asyncTask = new AsyncTaskPool(6)

// 用来保存共享的数据, 该功能目前使用场景是自由布局中的组件直接使用自由布局的应用数据
class ShareDataPool {
  constructor() {
    this.data = {}
  }
  setData(key, value) {
    this.data[key] = value
  }
  getData(key) {
    return this.data[key]
  }
}
export const shareDataPool = new ShareDataPool()

export const toSelectOpt = (des, opt) => {
  const res = []
  for (const k in des) {
    if (Object.hasOwnProperty.call(des, k)) {
      const item = des[k]
      res.push({
        label: item,
        value: k
      })
    }
  }
  return res
}
export async function sleep(time) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}
export async function collapseControl({ activeNames, collapseActiveNames, allCollapseNames }, time = 150) {
  for (let i = 0; i < allCollapseNames.length; i++) {
    const name = allCollapseNames[i]
    // await sleep(time)
    if (activeNames && !activeNames.includes(name)) {
      activeNames.push(name)
    }
    if (collapseActiveNames && !collapseActiveNames.includes(name)) {
      collapseActiveNames.push(name)
    }
  }
}
export function collapseMouseDown(collapseActiveNames, $event, val) {
  if ($event.target.classList[0] === "el-collapse-item__header") {
    const _index = collapseActiveNames.findIndex(it => it === val)
    _index === -1 ? collapseActiveNames.push(val) : ""
  }
}
export function getDocumentCookie(cookieName) {
  //获取所有的cookie "psw=1234we; rememberme=true; user=Annie"
  var totalCookie = document.cookie
  //获取参数所在的位置
  var cookieStartAt = totalCookie.indexOf(cookieName + "=")
  //判断参数是否存在 不存在直接返回
  if (cookieStartAt == -1) {
    return
  }
  //获取参数值的开始位置
  var valueStartAt = totalCookie.indexOf("=", cookieStartAt) + 1
  //以;来获取参数值的结束位置
  var valueEndAt = totalCookie.indexOf(";", cookieStartAt)
  //如果没有;则是最后一位
  if (valueEndAt == -1) {
    valueEndAt = totalCookie.length
  }
  //截取参数值的字符串
  var cookieValue = unescape(totalCookie.substring(valueStartAt, valueEndAt))
  return cookieValue
}
export async function getCookie(c_name) {
  let res = await api.getCookie({
    name: c_name
  })
  let names = c_name.split(",")
  let data = {}
  names.forEach(item => {
    data[item] = res.data.data[item] || ""
  })
  return data
}

/**
 * 格式化日期
 * 年-月-日
 * 年-月
 * 月-日
 * 月 日
 */
export function formatterDateHandle(data, flag, dateTitle = false, title) {
  let showDate = ""
  if (!data) {
    return dateTitle ? `${title}：${showDate}` : showDate
  }
  let currentDate = new Date(data)
  // 针对safari浏览器做兼容处理
  if (isNaN(currentDate.getFullYear())) {
    currentDate = new Date(data.replace(/-/g, "/"))
  }
  const year = currentDate.getFullYear()
  let month = currentDate.getMonth() + 1
  let day = currentDate.getDate()
  let hours = currentDate.getHours()
  let seconds = currentDate.getSeconds()
  let minutes = currentDate.getMinutes()
  month = month > 9 ? month : `0${month}`
  day = day > 9 ? day : `0${day}`
  hours = hours > 9 ? hours : `0${hours}`
  seconds = seconds > 9 ? seconds : `0${seconds}`
  minutes = minutes > 9 ? minutes : `0${minutes}`
  switch (flag) {
    case "1":
      showDate = `${year}-${month}-${day}`
      break
    case "2":
      showDate = `${year}-${month}`
      break
    case "3":
      showDate = `${month}-${day}`
      break
    case "4":
      showDate = `${year}`
      break
    case "5":
      showDate = `${month}`
      break
    case "6":
      showDate = `${day}`
      break
    case "7":
      showDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      break
    case "8":
      showDate = `${hours}:${minutes}`
      break
    case "9":
      showDate = `${data}`
      break
    case "10":
      showDate = `${year}-${month}-${day} ${hours}:${minutes}`
      break
    default:
  }
  return dateTitle ? `${title}：${showDate}` : showDate
}

/**
 * 替换url参数值
 * @param {*} url
 * @param {*} param
 * @param {*} value
 * @returns
 */
export function replaceUrlParam(url, param, value) {
  var $this = this
  var re = new RegExp("[?&](" + param + "=[^&]*)", "gi")
  var replaceStr = param + "=" + value
  return re.test(url)
    ? url.replace(RegExp.$1, replaceStr)
    : url.indexOf("?") > -1
    ? url + "&" + replaceStr
    : url + "?" + replaceStr
}
/**
 *
 * @param {HTMLElement} childEl 子元素dom
 * @param {HTMLElement} parentEl 父元素dom
 * @returns {cW: Number, cH: Number} cw：子元素宽度在父元素中的百分比，ch：子元素高度在父元素中的
 */
export function calcPercentSize(childEl, parentEl) {
  const { offsetWidth: oldChildW, offsetHeight: oldChildH } = childEl
  const { offsetWidth: parentW, offsetHeight: parentH } = parentEl
  return {
    cW: parseInt((oldChildW / parentW) * 100),
    cH: parseInt((oldChildH / parentH) * 100)
  }
}
/**
 * 插件执行函数
 * @param {array} pluginNames 插件名数组
 * @param {array|null} otherArgs 插件初始化函数接收的额外参数
 */
export function execPlugins(pluginNames, otherArgs) {
  //插件名有长度才执行
  if (pluginNames?.length) {
    const plugins = [...pluginNames].filter(it => it.trim().length)
    const fetchTag = "fetch-"
    plugins.forEach(pluginName => {
      //插件在当前组件中找到了,证明这个插件是以mixin的形式混入到本地的插件
      if (hasProperty(this, pluginName) && typeof this[pluginName] === "function") {
        this[pluginName](...otherArgs)
      } else if (pluginName.includes(fetchTag) && pluginName.length > fetchTag.length) {
        execPluginsFetch.call(this, pluginName, otherArgs, fetchTag)
      }
    })
  }
}
/**
 * fetch-插件执行
 * @param {string} pluginName  插件名
 * @param {object} otherArgs  属性options
 * @param {string} fetchTag   固定 "fetch-"
 * */
export function execPluginsFetch(pluginName, otherArgs, fetchTag) {
  //插件没有在组件中找到,且携带fetch-字符串,有可能是异步热重载插件
  let v = Date.now()
  instance
    .get(`sv2/assets/plugs_v2/${pluginName.slice(pluginName.indexOf(fetchTag) + fetchTag.length)}.json?v=${v}`)
    .then(res => {
      const fnStr = res?.data?.content
      if (fnStr && typeof fnStr === "string") {
        try {
          //当前的this里存在eventBus属性,说明当前execPlugins方法是在事件逻辑里执行的,事件需要传递更多参数,参数名也和组件内执行的插件不一致
          if (hasProperty(this, "eventBus")) {
            //有eventBus 证明是在插件系统当中调用的，this指向插件的实例
            const fn = new Function("from", "to", "currEventDes", fnStr)
            fn(...otherArgs)
          } else {
            //在组件内调用，this指向组件的实例
            const fn = new Function("ctx", fnStr)
            fn(this, ...otherArgs)
          }
        } catch (error) {
          console.log(error)
        }
      }
    })
}
/**
 * 初始化组件的插件执行逻辑
 * @param {array} pluginNames 组件的插件名数组
 * otherArg 该参数用来存放调用该插件中方法的参数
 */
export function initPlugin(pluginNames, otherArg, watchPath) {
  //没有pluginName,就初始化一个
  if (Array.isArray(pluginNames) === false && !!this.myid) {
    this.$changeOptionsEV([], "pluginName", false, null, this.myid)
    pluginNames = []
  }
  const _self = this
  const otherArgs = Array.isArray(otherArg) ? otherArg : []
  watchPath = watchPath ? watchPath : this.options.pluginName ? "options.pluginName" : "options.chartOption.pluginName"
  //todo earth组件会反复触发监听，这种情况仅存在于编辑页，待优化
  const debounce = _debounce.bind(this)
  //编辑页需要监听插件名数组的变化,在变化之后执行插件,预览页不需要,直接执行
  if (this.isBigScreenPreview() === false) {
    this.$watch(
      watchPath,
      function (n, o) {
        // !n.includes("loginLayoutComponent") 解决登录组件切换样式没有重新渲染插件
        if (n && n.includes("loginLayoutComponent")) debounce(execPlugins.call(_self, n, otherArgs), 500)
        if (JSON.stringify(n) === JSON.stringify(o)) return
        debounce(execPlugins.call(_self, n, otherArgs), 500)
      },
      { deep: true, immediate: true }
    )
  } else debounce(execPlugins.call(_self, this.hasProperty(this, watchPath), otherArgs), 500)
}

export function myDrag(
  { ctx = null, dragStart = function () {}, dragging = function () {}, dragEnd = function () {} },
  e
) {
  let status = true
  try {
    dragStart.call(ctx, e)
  } catch (e) {
    console.log(e)
  }
  function _dragging(e) {
    if (status) {
      status = false
      return
    }
    try {
      dragging.call(ctx, e)
    } catch (e) {
      console.log(e)
    }
  }
  function dragEndEv(e) {
    status = true
    try {
      dragEnd.call(ctx, e)
    } catch (e) {
      console.log(e)
    }
    window.removeEventListener("mousemove", _dragging)
    window.removeEventListener("mouseup", dragEndEv)
  }
  window.addEventListener("mousemove", _dragging)
  window.addEventListener("mouseup", dragEndEv)
}

export function updateSubPageNameHandle(pageId, name, wfwfid, type) {
  api
    .updatePageName({
      pageId: pageId,
      name: name + "-" + type,
      wfwfid: wfwfid
    })
    .then(res => {
      console.log("res", res)
    })
}
/**
 * 判定组件是否需要使用接口传参,注意!组件接口传参时,页面传参优先级大于事件传参
 * @param {object} options 组件的配置项
 * @returns
 */
export function getSwData(options) {
  if (!options) return ""
  let eventQuery = null
  try {
    //事件传参
    if (options?.eventQuery?.length) {
      if (isJSON(options.eventQuery)) {
        const query = JSON.parse(options.eventQuery)
        eventQuery = Object.values(query)
          .map(it => filterQuotation(it))
          .join("###")
      } else {
        eventQuery = options.eventQuery.trim()
      }
    }
  } catch (error) {
    eventQuery = null
  }
  const pageQuery =
    options?.usePageQuery && sessionStorage.getItem(window.pageQueryUid)?.length
      ? sessionStorage.getItem(window.pageQueryUid)
      : null
  return encodeURIComponent(pageQuery || eventQuery || "")
}
export function filterQuotation(str) {
  if (str[0] === '"') str = str.slice(1)
  if (str[0] === "'") str = str.slice(1)
  if (str[str.length - 1] === "'") str = str.slice(0, -1)
  if (str[str.length - 1] === '"') str = str.slice(0, -1)
  return str
}
export function isJSON(str) {
  if (typeof str == "string") {
    try {
      var obj = JSON.parse(str)
      // 等于这个条件说明就是JSON字符串 会返回true
      if (typeof obj == "object" && obj) {
        return true
      } else {
        //不是就返回false
        return false
      }
    } catch (e) {
      return false
    }
  }
  return false
}

/**
 * 自由布局根据当前col的uid找到所在的父级row
 * @param layout
 * @param uid
 */
export function handleFindLayoutComponentColsParentRowByUid(layout, uid) {
  if (!layout || layout?.length === 0) return
  let result = null
  const recursive = (data, uid) => {
    if (data.cols && data.cols.length > 0) {
      for (let i = 0; i < data.cols.length; i++) {
        let cols = data.cols[i]
        if (cols.uid === uid) {
          result = data
        } else {
          result = recursive(cols, uid)
        }
      }
    } else if (data.rows && data.rows.length > 0) {
      for (let j = 0; j < data.rows.length; j++) {
        let rows = data.rows[j]
        result = recursive(rows, uid)
      }
    }
    return result
  }
  for (let i = 0; i < layout.length; i++) {
    return recursive(layout[i], uid)
  }
}

/*
  二级页面获取首页名称和当前页名称
*/
export function getHomePageName($this) {
  const { websiteId, pageId, homePageId } = $this.$store.state.states.getDataPageIds
  api
    .queryEditPageList({
      websiteId: websiteId,
      pageId: pageId
    })
    .then(res => {
      if (res.data.code === 1 && res.data.data) {
        let name = ""
        if (homePageId === res.data.data.homePage?.publicId) {
          name = res.data.data.homePage?.name
        } else {
          let pageList = res.data.data.pageList || []
          name = pageList.find(it => it.publicId === homePageId).name
        }
        let subName = ""
        let nameArr = res.data.data.pageName?.split("-") || []
        if (nameArr.length > 1) {
          subName = nameArr[0]
        }
        $this.$store.commit("states/changeHomePageName", name)
      }
    })
}

export function getHtmlPlainText(html_str) {
  //提取字符串中的文字
  let re = new RegExp("<[^<>]+>", "g")
  let text = html_str.replace(re, "")
  return text
}

// 检查是否为异形布局
export function checkIrregularLayout(topOptions) {
  const topRows =
    topOptions.rows || topOptions.cols ? topOptions : Array.isArray(topOptions) ? topOptions[0] : [topOptions]
  const copyTopRows = JSON.parse(JSON.stringify(topRows))
  copyTopRows.top = 0
  copyTopRows.left = 0
  copyTopRows.height = 100
  copyTopRows.width = 100
  const leafNodes = []
  travelLayout(copyTopRows, leafNodes)
  const [topMapResult, isSameTop] = compareNodesByTopOrLeft(leafNodes, "top")
  const [leftMapResult, isSameLeft] = compareNodesByTopOrLeft(leafNodes, "left")
  // 如果已经是行对齐，就按照行对齐计算；否则，按照列对齐计算
  const mapResult = isSameTop ? topMapResult : leftMapResult
  const isSame = isSameTop ? isSameTop : isSameLeft
  const numArr = Object.values(mapResult)
  if (numArr.length === 1 && isSame) {
    return {
      regular: true,
      rowLens: isSameTop ? 1 : numArr[0],
      colLens: isSameTop ? numArr[0] : 1
    }
  } else {
    const regular = numArr.reduce((pre, post) => pre && numArr[0] === post, true) && isSame
    return regular
      ? {
          regular: true,
          rowLens: isSameTop ? numArr.length : numArr[0],
          colLens: isSameTop ? numArr[0] : numArr.length
        }
      : {
          regular: false,
          rowLens: null,
          colLens: null
        }
  }
}

// 遍历自由布局layout，为每个节点计算定位信息
function travelLayout(data, obj = []) {
  if (data.cols) {
    data.cols.forEach((item, index) => {
      // cols没有高度记录，需要从父节点取到
      item.height = data.height
      item.top = data.top
      item.width = item.width || `${item.md / item.appMd}%`
      // 每一列需要从之前兄弟节点叠加宽度和左部定位
      item.width = +((data.width * item.width.replace("%", "")) / 100).toFixed(2)
      if (index === 0) {
        item.left = data.left
      } else {
        const lastSibling = data.cols[index - 1]
        item.left = +(lastSibling.left + lastSibling.width).toFixed(2)
      }
      travelLayout(item, obj)
    })
  } else if (data.rows) {
    data.rows.forEach((item, index) => {
      // rows没有宽度记录，需要从父节点取到
      item.width = data.width
      item.left = data.left
      // 每一行需要从之前兄弟节点叠加高度和上部定位
      item.height = +((data.height * item.height.replace("%", "")) / 100).toFixed(2)
      if (index === 0) {
        item.top = data.top
      } else {
        const lastSibling = data.rows[index - 1]
        item.top = +(lastSibling.top + lastSibling.height).toFixed(2)
      }
      travelLayout(item, obj)
    })
  } else {
    obj.push(data)
  }
}

// 通过左对齐，或者上对齐，分类所有单元格
function compareNodesByTopOrLeft(leafNodes, type) {
  const mapResult = {}
  // 同一top的单元格，高度必须一样，才不是异形布局；同一left的单元格，宽度必须一样，才不是异形布局
  const mapHeight = {}
  let isSame = true
  leafNodes.forEach(node => {
    const base = type === "top" ? node.top : node.left
    const comparePoint = type === "top" ? node.height : node.width
    // 需要上下取0.01的误差，因为在增减列时，有涉及四则运算，且保留2位小数，有精度损失
    const low = +(base - 0.01).toFixed(2)
    const up = +(base + 0.01).toFixed(2)
    if (!mapResult[base] && !mapResult[low] && !mapResult[up]) {
      mapResult[base] = 1
    } else {
      if (!mapResult[low] && !mapResult[up]) {
        mapResult[base]++
      } else if (mapResult[low]) {
        mapResult[low]++
      } else if (mapResult[up]) {
        mapResult[up]++
      }
    }
    if (!mapHeight[base] && !mapHeight[low] && !mapHeight[up]) {
      mapHeight[base] = comparePoint
    } else {
      if (mapHeight[base] && mapHeight[base] !== comparePoint) {
        isSame = false
      }
      if (mapHeight[low] && mapHeight[low] !== comparePoint) {
        isSame = false
      }
      if (mapHeight[up] && mapHeight[up] !== comparePoint) {
        isSame = false
      }
    }
  })
  return [mapResult, isSame]
}

// 寻找需要删除的uid集合
export function findDeleteLayout(topOptions, rowsLen, colsLen, layoutType) {
  const topRows = topOptions.rows || topOptions.cols ? topOptions : [topOptions]
  const copyTopRows = JSON.parse(JSON.stringify(topRows))
  copyTopRows.top = 0
  copyTopRows.left = 0
  copyTopRows.width = 100
  copyTopRows.height = 100
  const leafNodes = []
  travelLayoutPosition(copyTopRows, leafNodes)
  const mapResult = {}
  leafNodes.forEach(node => {
    // 需要上下取0.01的误差，因为在增减列时，有涉及四则运算，且保留2位小数，有精度损失
    const base = layoutType === "row" ? node.top : node.left
    const low = +(base - 0.01).toFixed(2)
    const up = +(base + 0.01).toFixed(2)
    if (!mapResult[base] && !mapResult[low] && !mapResult[up]) {
      mapResult[base] = [node]
    } else {
      if (!mapResult[low] && !mapResult[up]) {
        mapResult[base].push(node)
      } else if (mapResult[low]) {
        mapResult[low].push(node)
      } else if (mapResult[up]) {
        mapResult[up].push(node)
      }
    }
  })
  for (let i in mapResult) {
    if (layoutType === "row") {
      mapResult[i].sort((pre, post) => pre.left - post.left)
    } else {
      mapResult[i].sort((pre, post) => pre.top - post.top)
    }
  }
  const keys = Object.keys(mapResult).sort((pre, post) => pre - post)
  const rect = []
  if (layoutType === "row") {
    for (let i = 0; i < keys.length; i++) {
      rect.push(mapResult[keys[i]])
    }
  } else {
    for (let i = 0; i < mapResult[keys[0]].length; i++) {
      const row = []
      for (let j = 0; j < keys.length; j++) {
        row.push(mapResult[keys[j]][i])
      }
      rect.push(row)
    }
  }
  const deleteUidS = []
  for (let i in rect) {
    for (let j in rect[i]) {
      if (i >= rowsLen || j >= colsLen) {
        deleteUidS.push(rect[i][j].uid)
      }
    }
  }
  return deleteUidS
}

// 遍历自由布局layout，记录位置信息
function travelLayoutPosition(data, obj = []) {
  if (data.cols) {
    data.cols.forEach((item, index) => {
      item.width = (data.width * item.width.replace("%", "")) / 100
      if (index === 0) {
        item.left = data.left
      } else {
        const lastSibling = data.cols[index - 1]
        item.left = lastSibling.left + lastSibling.width
      }
      // cols没有高度记录，需要从父节点取到
      item.height = data.height
      item.top = data.top
      travelLayoutPosition(item, obj)
    })
  } else if (data.rows) {
    // 每一行需要从之前兄弟节点叠加高度和上部定位
    data.rows.forEach((item, index) => {
      item.height = +((data.height * item.height.replace("%", "")) / 100).toFixed(2)
      if (index === 0) {
        item.top = data.top
      } else {
        const lastSibling = data.rows[index - 1]
        item.top = lastSibling.top + lastSibling.height
      }
      // rows没有宽度记录，需要从父节点取到
      item.width = data.width
      item.left = data.left
      travelLayoutPosition(item, obj)
    })
  } else {
    obj.push(data)
  }
}

// 删除不需要的布局元素
export function deleteLayout(options, deleteUidS) {
  const layout = JSON.parse(JSON.stringify(options))
  markParentAndRemove(layout, deleteUidS)
  removeParent(layout)
  resizeTopLayout(layout)
  resizeLayout(layout)
  return layout
}
// 删除编组后自由布局内的 不需要的布局元素
export function deleteGroupLayout(options, deleteUidS) {
  const layout = JSON.parse(JSON.stringify(options))
  markParentAndRemove(layout, deleteUidS)
  removeParent(layout)
  resizeTopLayout(layout)
  resizeLayout(layout)
  return layout
}

// 遍历设置布局元素的父元素，并在底层执行删除操作
function markParentAndRemove(options, deleteUidS) {
  if (options.rows) {
    for (let i = options.rows.length - 1; i >= 0; i--) {
      options.rows[i].parent = options
      markParentAndRemove(options.rows[i], deleteUidS)
    }
  } else if (options.cols) {
    for (let i = options.cols.length - 1; i >= 0; i--) {
      options.cols[i].parent = options
      if (deleteUidS.includes(options.cols[i].uid)) {
        removeItemFromParent(options.cols[i], deleteUidS)
      } else {
        markParentAndRemove(options.cols[i], deleteUidS)
      }
    }
  } else {
    if (deleteUidS.includes(options.uid)) {
      removeItemFromParent(options, deleteUidS)
    }
  }
}

// 从父节点中回溯删除该元素
function removeItemFromParent(options, deleteUidS) {
  // 没有父节点的顶点，删除rows属性
  if (!options.parent) {
    delete options.rows
    return
  }
  if (options.parent.rows) {
    // 从父节点删除该元素
    const idx = options.parent.rows.findIndex(row => row === options)
    options.parent.rows.splice(idx, 1)
    // 父节点下没有元素的，继续向上回溯，删除节点
    if (options.parent.rows.length === 0) {
      removeItemFromParent(options.parent, deleteUidS)
    }
  } else if (options.parent.cols) {
    // 从父节点删除该元素
    const idx = options.parent.cols.findIndex(col => col === options)
    options.parent.cols.splice(idx, 1)
    // 父节点下没有元素的，继续向上回溯，删除节点
    if (options.parent.cols.length === 0) {
      removeItemFromParent(options.parent, deleteUidS)
    }
  }
}

// 删除父节点信息
function removeParent(options) {
  delete options.parent
  if (options.rows) {
    for (let row of options.rows) {
      removeParent(row)
    }
  } else if (options.cols) {
    for (let col of options.cols) {
      removeParent(col)
    }
  }
}

// 处理顶层容器宽高
function resizeTopLayout(options) {
  if (options.rows) {
    const regularResult = checkIrregularLayout(options.rows)
    const total = regularResult.rowLens
    if (regularResult.regular) {
      for (let row of options.rows) {
        const currentResult = checkIrregularLayout(row)
        if (currentResult.regular) {
          const cur = currentResult.rowLens
          row.height = `${((cur / total) * 100).toFixed(2)}%`
        }
      }
    }
  } else if (options.cols) {
    const regularResult = checkIrregularLayout(options.cols)
    const total = regularResult.colLens
    if (regularResult.regular) {
      for (let col of options.cols) {
        const currentResult = checkIrregularLayout(col)
        if (currentResult.regular) {
          const cur = currentResult.colLens
          col.width = `${((cur / total) * 100).toFixed(2)}%`
        }
      }
    }
  }
}

// 重新改变尺寸信息
function resizeLayout(options) {
  if (options.rows) {
    let total = 0
    for (let row of options.rows) {
      total += Number(row.height.replace("%", ""))
    }
    for (let row of options.rows) {
      const height = Number(row.height.replace("%", ""))
      row.height = `${((height / total) * 100).toFixed(2)}%`
      resizeLayout(row)
    }
  } else if (options.cols) {
    let total = 0
    for (let col of options.cols) {
      total += Number(col.width.replace("%", ""))
    }
    for (let col of options.cols) {
      const width = Number(col.width.replace("%", ""))
      col.width = `${((width / total) * 100).toFixed(2)}%`
      resizeLayout(col)
    }
  }
}

// 查找历史数据是行布局还是列布局
export function findHistoryLayoutType(options) {
  let layoutType = ""
  let opt = null
  let maxRow = 1
  let maxCol = 1
  function travel(attr) {
    if (attr.rows) {
      // 先出现行大于1的情况下，视作行布局
      if (attr.rows.length > 1) {
        maxRow = Math.max(maxRow, attr.rows.length)
        layoutType = layoutType || "row"
        opt = opt || attr
        for (let row of attr.rows) {
          travel(row)
        }
      } else {
        travel(attr.rows[0])
      }
    } else if (attr.cols) {
      // 先出现列大于1的情况下，视作列布局
      if (attr.cols.length > 1) {
        maxCol = Math.max(maxCol, attr.cols.length)
        layoutType = layoutType || "col"
        opt = opt || attr
        for (let col of attr.cols) {
          travel(col)
        }
      } else {
        travel(attr.cols[0])
      }
    }
  }
  travel(options)
  opt = opt || options
  // 多行一列，也视为列布局
  if (maxRow > 1 && maxCol === 1) {
    layoutType = "col"
  }
  // 多行一列，也视为行布局
  if (maxCol > 1 && maxRow === 1) {
    layoutType = "row"
  }
  return [layoutType, opt]
}

// 深拷贝数据
export function simpleDeepClone(target, map = new WeakMap()) {
  if (typeof target === "object" && target !== null) {
    // 如果在表中已经存在该对象，则直接返回表中引用的对象，而不是重复递归，导致死循环栈溢出
    if (map.get(target)) {
      return map.get(target)
    }
    let cloneTarget = Array.isArray(target) ? [] : {}
    map.set(target, cloneTarget)
    for (const key in target) {
      cloneTarget[key] = simpleDeepClone(target[key], map)
    }
    return cloneTarget
  } else {
    return target
  }
}

// 寻找配置路径，mode表示查找方式，默认相等，可查找包含
export function findPath(data, target, suffix, mode = "equal", property) {
  let finalPath = ""
  const find = (newVal, path) => {
    if (getDataType(newVal) === "Object") {
      for (let i in newVal) {
        const newPath = path ? `${path}.${i}` : `${i}`
        if (property && i !== property) {
          find(newVal[i], newPath)
        } else if (mode === "equal" && newVal[i] === target) {
          finalPath = newPath
        } else if (mode === "include" && Array.isArray(newVal[i]) && newVal[i].includes(target)) {
          finalPath = newPath
        } else {
          find(newVal[i], newPath)
        }
      }
    }
    if (getDataType(newVal) === "Array") {
      for (let i in newVal) {
        const newPath = `${path}[${i}]`
        if (property && i !== property) {
          find(newVal[i], newPath)
        } else if (mode === "equal" && newVal[i] === target) {
          finalPath = newPath
        } else if (mode === "include" && Array.isArray(newVal[i]) && newVal[i].includes(target)) {
          finalPath = newPath
        } else {
          find(newVal[i], newPath)
        }
      }
    }
  }
  find(data, "")
  return `${finalPath}.${suffix}`
}

// 获取数据类型
function getDataType(data) {
  const typeStr = Object.prototype.toString.call(data)
  return typeStr.slice(8, -1)
}

// 判断两个对象或者数组内容是否相等
export function isEqual(obj1, obj2, map = new WeakMap()) {
  if (!isObject(obj1) || !isObject(obj2)) {
    return obj1 === obj2
  }
  if (obj1 === obj2) {
    return true
  }
  let obj1_len = 0
  if (Array.isArray(obj1)) {
    obj1_len = obj1.length
  } else {
    for (let i in obj1) {
      if (obj1[i] !== undefined) {
        obj1_len++
      }
    }
  }
  let obj2_len = 0
  if (Array.isArray(obj2)) {
    obj2_len = obj2.length
  } else {
    for (let i in obj2) {
      if (obj2[i] !== undefined) {
        obj2_len++
      }
    }
  }
  if (obj1_len !== obj2_len) {
    return false
  }
  // 环状数据默认它为始终不等的
  if (map.get(obj1)) {
    return false
  } else {
    map.set(obj1, true)
    for (let key in obj1) {
      const res = isEqual(obj1[key], obj2[key], map)
      if (!res) {
        return false
      }
    }
  }
  return true
}

// 判断是否为对象类型
function isObject(obj) {
  return typeof obj === "object" && obj !== null
}

// 判断不为空
export function isExist(value) {
  if (value !== null && typeof value !== "undefined") {
    return true
  }
  return false
}

// 区分上层是布局还是画布
//  当前目标ID rectId,说明当前选中的是组件
//  当前父组件的id  parentRectId,说明选中的是布局标签的布局
function getContainerInfo(pageLayoutType, ids, stage, isShowVerticalTabs, isAccordionLayout) {
  let handleInfo
  //  先判断是不是在栅格中->带标签布局
  let parentRect
  if (pageLayoutType) {
    let layoutIndex
    if (ids.pageLayoutId && ids.pageLayoutId.toString().indexOf("_") > -1) {
      // 取布局
      layoutIndex = ids.pageLayoutId
      // 先找组件，如果在组件内则是带组件标签，否则是老的布局
      if (isExist(ids.parentRectId)) {
        parentRect = $(`.container_id_${ids.container_id}-rect_id_${ids.parentRectId}`)[0]
      } else if (ids.curRectId) {
        parentRect = $(`.container_id_${ids.container_id}-rect_id_${ids.curRectId}`).parents(".vdr")[0]
      }
    } else if (ids.pageLayoutId && ids.pageLayoutId.toString().indexOf("_") === -1) {
      // 取通栏
      layoutIndex = ids.pageLayoutId
      // layoutIndex = $(`#layout_${ids.pageLayoutId}_0`).parents(".page-layout-wrapper").attr("layoutindex")
    } else if (isExist(ids.rect_id) || isExist(ids.curRectId)) {
      const _rect_id = isExist(ids.rect_id) ? ids.rect_id : ids.curRectId
      parentRect = $(`.container_id_${ids.container_id}-rect_id_${_rect_id}`).parents(".vdr")[0]
      layoutIndex = $(
        $(`.container_id_${ids.container_id}-rect_id_${_rect_id}`).parents(".layout-cell-container")[0]
      ).attr("layoutindex")
      // if(!parentRect && layoutIndex.split("_").length === 2){
      //   // 标签布局中的组件
      //   let layoutIndex1 = $(`.container_id_${ids.container_id}-rect_id_${_rect_id}`).parents(".page-layout-wrapper").attr("layoutindex")
      // }
    } else {
      handleInfo = {
        name: "页面",
        iconClass: "icon-portal-page-layer",
        shape: "page",
        ids: {}
      }
      return handleInfo
    }
    if (layoutIndex === "undefined" || typeof layoutIndex === "undefined") {
      return
    }
    let rectId = ids.parentRectId // 此时的rectId 为父组件的rectId
    if (parentRect && !isExist(rectId)) {
      let rectIdClassName = Array.from(parentRect.classList).filter(it => it.includes("container_id_"))
      rectIdClassName = rectIdClassName[0]?.split("_")
      rectId = rectIdClassName[rectIdClassName.length - 1]
      rectId = isNaN(Number(rectId)) ? null : Number(rectId)
    }
    // 考虑新画布方式，即通栏+画布+布局模式
    if (!isExist(ids.rect_id) && !isExist(ids.curRectId)) {
      // 当前为组件时，往上找布局，layoutIndex直接使用
      let upperLayoutIndex = layoutIndex.toString().split("_")
      if (upperLayoutIndex.length === 2) {
        let layoutDiv = isExist(ids.parentRectId)
          ? `.container_id_${ids.container_id}-rect_id_${ids.parentRectId}`
          : `#layout_${upperLayoutIndex.join("_")}`
        layoutIndex = $(layoutDiv).parents(".page-layout-wrapper").attr("layoutIndex")
        layoutIndex = stage.page.pageLayoutList.findIndex(item => item.id == layoutIndex)
      } else {
        upperLayoutIndex.splice(-1, 1)
        layoutIndex = upperLayoutIndex.join("_")
      }
    }
    let pageLayoutName = "布局"
    // if(isExist(rectId) && pageLayoutType === 'waterFall' && layoutIndex.toString().split("_").length === 2){
    //   layoutIndex = layoutIndex.toString().split("_")[0]
    // }
    if (layoutIndex.toString().indexOf("_") === -1 && layoutIndex.toString().length > 0) {
      // const options = stage.page.pageLayoutList.find(item => item.id == layoutIndex)?.options
      const options = stage.page.pageLayoutList[layoutIndex]?.options
      const pageLayoutType = options?.inDocument
      const isBayWindow = options?.enableBayWindow
      switch (pageLayoutType) {
        case "header":
          pageLayoutName = "头部"
          break
        case "footer":
          pageLayoutName = "底部"
          break
        case "anchor":
          pageLayoutName = "锚点"
          break
        case "drawer":
          pageLayoutName = "抽屉"
          break
        case "popover":
          pageLayoutName = "弹出框"
          break
        default:
          pageLayoutName = isBayWindow ? "飘窗" : "通栏"
      }
    } else if (layoutIndex.toString().length === 0) {
      return {
        name: "页面",
        iconClass: "icon-portal-page-layer",
        shape: "page",
        ids: {}
      }
    }
    if (isExist(rectId)) {
      // 标签布局处理为组件 -> 标签组件 -> 通栏
      const layoutLevel = layoutIndex.toString().split("_").length
      const upperLevel = isShowVerticalTabs ? 4 : isAccordionLayout ? 2 : 3
      let _ids
      if (layoutLevel > upperLevel) {
        _ids = {
          container_id: ids.container_id,
          rect_id: rectId,
          pageLayoutId: layoutIndex
        }
      } else {
        _ids = {
          container_id: ids.container_id,
          rect_id: rectId
        }
      }
      handleInfo = {
        name: layoutLevel > upperLevel ? pageLayoutName : isAccordionLayout ? "手风琴布局" : isShowVerticalTabs ? "竖向标签" : "横向标签",
        iconClass: layoutLevel > upperLevel ? "icon-portal-container" : isAccordionLayout ? 'icon-portal-accordion' : "icon-portal-artboard_1",
        shape: layoutLevel > upperLevel ? "cxPageLayoutComponentCell" : "cxPageLayoutComponent",
        ids: _ids
      }
      // } else if(pageLayoutType === 'waterFall'){
      //   // 判断是不是根布局,如果为两层就显示上传布局 即通栏
      //   let layoutIndexArr = layoutIndex.toString().split("_")
      //   handleInfo = {
      //     name: pageLayoutName ,
      //     iconClass: layoutIndexArr.length > 2 ? "icon-portal-container" : "icon-portal-artboard_1",
      //     shape: layoutIndexArr.length > 2 ? "cxPageLayoutCell" : "cxPageLayout",
      //     ids: {
      //       container_id: ids.container_id,
      //       pageLayoutId: layoutIndexArr.length>2 ? layoutIndex : layoutIndexArr[0]
      //     }
      //   }
    } else {
      const ids = layoutIndex.toString().split("_")
      const pageLayout = getAttrById(stage, {
        container_id: ids.container_id,
        pageLayoutId: ids[0]
      })
      isAccordionLayout = pageLayout?.options?.isAccordionLayout
      // 旧布局逻辑
      handleInfo = {
        name: ids.length === 2 && isAccordionLayout ? "手风琴布局" : pageLayoutName,
        iconClass: ids.length === 2 && isAccordionLayout ? 'icon-portal-accordion' : layoutIndex.toString().split("_").length > 1 ? "icon-portal-container" : "icon-portal-artboard_1",
        shape: layoutIndex.toString().split("_").length > 1 ? "cxPageLayoutCell" : "cxPageLayout",
        ids: {
          container_id: ids.container_id,
          pageLayoutId: layoutIndex
        }
      }
    }
  }
  // else {
  //   handleInfo = {
  //     name: "画布",
  //     iconClass: "icon-portal-container",
  //     shape: "container",
  //     ids: {
  //       container_id: ids.container_id
  //     }
  //   }
  // }
  return handleInfo
}
/*
 * 查找组件是否包含某个插件
 * elementOptions 当前组件options
 * pluginName 插件名
 */
export function isHasPlugins(elementOptions, pluginName) {
  if (elementOptions && elementOptions.pluginName && elementOptions.pluginName.includes(pluginName)) {
    return true
  } else {
    return false
  }
}

/**
 * 从当前组件往上找三层
 * @param ids 当前组件的ids
 * @param pageLayoutType 当前页面的类型  是否为布局模式
 * @param stage
 */
export function findParentIds(ids, pageLayoutType, stage) {
  // 往上找，最多三级
  let handleList = []
  let secondBtn, firstBtn
  let emptyLayout = getAttrById(stage, {
    container_id: ids.container_id,
    rect_id: ids.rect_id
  })?.options
  let autoLayout = undefined
  // if (emptyLayout && emptyLayout.innerElement === "cxAutoLayout" ) {
  //   emptyLayout = emptyLayout.elementOptions.find(it => it.elementInAutoLayoutId === ids.elementInAutoLayoutId)
  // }
  if (ids.elementInAutoLayoutId !== undefined && ids.elementInAutoLayoutId !== null) {
    // 查找当前组件所在的父组件
    // todo_zxf
    autoLayout = getAttrById(
      stage,
      {
        ...ids,
        uid: undefined,
        elementInLayoutId: undefined
      },
      "autoLayout"
    )
    if (autoLayout && autoLayout.innerElement === "cxAutoLayout") {
      // 如果是自动布局说明当前组件在自动布局中
      let newEmptyLayout = autoLayout.elementOptions?.find(it => it.elementInAutoLayoutId === ids.elementInAutoLayoutId)
      newEmptyLayout !== undefined ? (emptyLayout = newEmptyLayout) : ""
    } else {
      // 如果不是说明是自动布局在自由布局中
      // todo_zxf
      autoLayout = getAttrById(stage, ids, "autoLayout")
    }
  }
  // console.log('autoLayout :>>',autoLayout);
  if (ids.uid) {
    // 单元格
    if (!isExist(ids.elementInLayoutId)) {
      const useActiveIndex = emptyLayout.categoryMode === CATEGORY_MODE.SAME ? 0 : emptyLayout.activeIndex
      const uids = getEffectiveLayoutUid(emptyLayout.rows[useActiveIndex], ids.uid, stage)
      switch (uids.length) {
        case 0:
          secondBtn = {
            name: emptyLayout?.menuName,
            iconClass: emptyLayout?.menuIconClass,
            shape: "emptyLayoutComponent",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id
            }
          }
          firstBtn = getContainerInfo(pageLayoutType, ids, stage)
          // 当前自由布局在自动布局中
          if (isExist(ids.elementInAutoLayoutId)) {
            secondBtn = {
              name: emptyLayout?.menuName,
              iconClass: emptyLayout?.menuIconClass,
              shape: "emptyLayoutComponent",
              ids: {
                container_id: ids.container_id,
                rect_id: ids.rect_id,
                elementInAutoLayoutId: ids.elementInAutoLayoutId,
                path: ids.path
              }
            }
            firstBtn = {
              name: autoLayout?.menuName,
              iconClass: autoLayout?.menuIconClass,
              shape: "cxAutoLayout",
              ids: {
                container_id: ids.container_id,
                rect_id: ids.rect_id,
                elementInAutoLayoutId: ids.elementInAutoLayoutId,
                path: ids.path
              }
            }
          }
          break
        case 1:
          secondBtn = {
            name: "单元格",
            iconClass: "icon-portal-grid",
            shape: "colsComponent",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id,
              uid: uids[0],
              elementInAutoLayoutId: ids.elementInAutoLayoutId,
              path: ids.path
            }
          }
          firstBtn = {
            name: emptyLayout?.menuName,
            iconClass: emptyLayout?.menuIconClass,
            shape: "emptyLayoutComponent",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id,
              elementInAutoLayoutId: ids.elementInAutoLayoutId,
              path: ids.path
            }
          }
          break
        default:
          secondBtn = {
            name: "单元格",
            iconClass: "icon-portal-grid",
            shape: "colsComponent",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id,
              uid: uids[0],
              elementInAutoLayoutId: ids.elementInAutoLayoutId,
              path: ids.path
            }
          }
          firstBtn = {
            name: "单元格",
            iconClass: "icon-portal-grid",
            shape: "colsComponent",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id,
              uid: uids[1],
              elementInAutoLayoutId: ids.elementInAutoLayoutId,
              path: ids.path
            }
          }
      }
    }
    // 单元格内的组件
    else if (ids.uid && isExist(ids.elementInLayoutId)) {
      // 不显示单元格的组件处理
      if (
        emptyLayout &&
        (isHasPlugins(emptyLayout, "loginLayoutComponent") ||
          emptyLayout.name === "超星头像" ||
          emptyLayout.name === "列表页搜索" ||
          isHasPlugins(emptyLayout, "searchComponentPlugin") ||
          isHasPlugins(emptyLayout, "loginEngineComponentPlugin"))
      ) {
        secondBtn = {
          name: emptyLayout.name === "列表页搜索" ? emptyLayout.name : emptyLayout?.menuName,
          iconClass: emptyLayout?.menuIconClass,
          shape: "emptyLayoutComponent",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id
          }
        }
        firstBtn = getContainerInfo(pageLayoutType, ids, stage)
        // 自由布局中在自动布局中
        if (isExist(ids.elementInAutoLayoutId) && isExist(emptyLayout.elementInAutoLayoutId)) {
          secondBtn = {
            name: emptyLayout.name === "列表页搜索" ? emptyLayout.name : emptyLayout?.menuName,
            iconClass: emptyLayout?.menuIconClass,
            shape: "emptyLayoutComponent",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id,
              elementInAutoLayoutId: ids.elementInAutoLayoutId,
              path: ids.path
            }
          }
          firstBtn = {
            name: autoLayout?.menuName,
            iconClass: autoLayout?.menuIconClass,
            shape: "cxAutoLayout",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id
            }
          }
        }
        // 自动布局在自由布局中
        if (isExist(ids.elementInAutoLayoutId) && !isExist(emptyLayout.elementInAutoLayoutId)) {
          secondBtn = {
            name: autoLayout?.menuName,
            iconClass: autoLayout?.menuIconClass,
            shape: "cxAutoLayout",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id,
              elementInLayoutId: ids.elementInLayoutId,
              path: ids.path,
              uid: ids.uid
            }
          }
          firstBtn = {
            name: emptyLayout.name === "列表页搜索" ? emptyLayout.name : emptyLayout?.menuName,
            iconClass: emptyLayout?.menuIconClass,
            shape: "emptyLayoutComponent",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id
            }
          }
        }
      } else {
        secondBtn = {
          name: "单元格",
          iconClass: "icon-portal-grid",
          shape: "colsComponent",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id,
            uid: ids.uid,
            elementInAutoLayoutId: ids.elementInAutoLayoutId,
            path: ids.path
          }
        }
        const useActiveIndex = emptyLayout.categoryMode === CATEGORY_MODE.SAME ? 0 : emptyLayout.activeIndex
        const uids = getEffectiveLayoutUid(emptyLayout.rows[useActiveIndex], ids.uid, stage)
        if (uids.length > 0) {
          firstBtn = {
            name: "单元格",
            iconClass: "icon-portal-grid",
            shape: "colsComponent",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id,
              uid: uids[0],
              elementInAutoLayoutId: ids.elementInAutoLayoutId,
              path: ids.path
            }
          }
        } else {
          firstBtn = {
            name: emptyLayout?.menuName,
            iconClass: emptyLayout?.menuIconClass,
            shape: "emptyLayoutComponent",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id,
              elementInAutoLayoutId: ids.elementInAutoLayoutId,
              path: ids.path
            }
          }
        }
        // 自动布局在自由布局中
        if (isExist(ids.elementInAutoLayoutId) && !isExist(emptyLayout.elementInAutoLayoutId)) {
          secondBtn = {
            name: autoLayout?.menuName,
            iconClass: autoLayout?.menuIconClass,
            shape: "cxAutoLayout",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id,
              uid: ids.uid,
              elementInLayoutId: ids.elementInLayoutId
            }
          }
          firstBtn = {
            name: "单元格",
            iconClass: "icon-portal-grid",
            shape: "colsComponent",
            ids: {
              container_id: ids.container_id,
              rect_id: ids.rect_id,
              uid: uids?.length > 0 ? uids[0] : ids.uid
            }
          }
        }
      }
    }
  }
  if (!ids.uid) {
    // 布局内的组件  组件-》布局-》
    // 先判断是不是横向、竖向标签
    let isShowVerticalTabs = false
    let isAccordionLayout = false
    let parentRect, cxPageLayoutId
    if (isExist(ids.rect_id) && isExist(ids.pageLayoutId)) {
      parentRect = $(`#rect_id_${ids.rect_id}_layout_${ids.pageLayoutId}`).parents(".vdr")[0]
    } else if (isExist(ids.rect_id) && !isExist(ids.pageLayoutId)) {
      parentRect = $(`.container_id_${ids.container_id}-rect_id_${ids.rect_id}`).parents(".vdr")[0]
    } else if (!isExist(ids.rect_id) && isExist(ids.pageLayoutId)) {
      const pageLayout = getAttrById(stage, {
        container_id: ids.container_id,
        pageLayoutId: ids.pageLayoutId?.toString().split("_")[0]
      })
      isAccordionLayout = pageLayout?.options?.isAccordionLayout
    }
    if (parentRect) {
      let parentRectId
      for (let i = 0; i < parentRect.classList.length; i++) {
        if (parentRect.classList[i].indexOf("rect_id_") > -1) {
          parentRectId = parentRect.classList[i].split("rect_id_")[1]
          break
        }
      }
      if (parentRectId) {
        // 判断是不是横、竖向标签
        const parentOptions = getAttrById(stage, {
          container_id: ids.container_id,
          rect_id: Number(parentRectId)
        })
        isShowVerticalTabs = parentOptions?.options.layout.options.isShowVerticalTabs
        isAccordionLayout = parentOptions?.options.layout.options.isAccordionLayout
      }
      cxPageLayoutId = $($(parentRect).parents(".layout-cell-container")[0]).attr("layoutindex")
    }
    if (
      isExist(ids.rect_id) &&
      !isExist(ids.elementInSwiperId) &&
      !isExist(ids.elementInLayoutId) &&
      !isExist(ids.elementInAutoLayoutId) &&
      !isExist(ids.pageLayoutId) &&
      !isExist(ids.cellId) &&
      !isExist(ids.elementInDataGridId)
    ) {
      secondBtn = getContainerInfo(pageLayoutType, ids, stage, isShowVerticalTabs, isAccordionLayout)
      if (!secondBtn || !secondBtn.ids) {
        return
      }
      const secondPageLayoutId = secondBtn.ids.pageLayoutId?.toString().split("_")
      if (pageLayoutType && secondPageLayoutId?.length > 1) {
        let layoutIndex = secondBtn.ids.pageLayoutId
        // 一帆需求，特殊的布局层需要隐藏
        const hideLevel = isShowVerticalTabs ? 5 : 4
        let pageLayoutLevel = layoutIndex.toString().split("_")
        let pageLayoutId = layoutIndex
        if (pageLayoutLevel[pageLayoutLevel.length - 2] > 0 && pageLayoutLevel.length === hideLevel) {
          // 满足条件，需要隐藏
          pageLayoutLevel.splice(-1, 1)
        }
        pageLayoutLevel.splice(-1, 1)
        pageLayoutId = pageLayoutLevel.join("_")
        firstBtn = getContainerInfo(
          pageLayoutType,
          {
            container_id: ids.container_id,
            curRectId: ids.rect_id,
            pageLayoutId: pageLayoutId
          },
          stage,
          isShowVerticalTabs,
          isAccordionLayout
        )
      } else {
        firstBtn = {
          name: "页面",
          iconClass: "icon-portal-page-layer",
          shape: "page",
          ids: {}
        }
      }
    }
    // 带标签布局中的布局（栅格模式下）
    else if (isExist(ids.rect_id) && isExist(ids.pageLayoutId)) {
      const upperLevel = isShowVerticalTabs ? 3 : 2
      // 一帆需求，特殊的布局层需要隐藏
      const hideLevel = isShowVerticalTabs ? 5 : 4
      let pageLayoutLevel = ids.pageLayoutId.toString().split("_")
      let pageLayoutId = ids.pageLayoutId
      if (pageLayoutLevel[pageLayoutLevel.length - 2] > 0 && pageLayoutLevel.length === hideLevel) {
        // 满足条件，需要隐藏
        pageLayoutLevel.splice(-1, 1)
        pageLayoutId = pageLayoutLevel.join("_")
      }
      secondBtn = getContainerInfo(
        pageLayoutType,
        {
          container_id: ids.container_id,
          parentRectId: ids.rect_id,
          pageLayoutId: pageLayoutId
        },
        stage,
        isShowVerticalTabs,
        isAccordionLayout
      )
      if (pageLayoutLevel.length > upperLevel + 1) {
        let upperLayoutId = pageLayoutId.toString().split("_")
        upperLayoutId.splice(-1, 1)
        if (upperLayoutId[upperLayoutId.length - 2] > 0 && upperLayoutId.length === hideLevel) {
          upperLayoutId.splice(-1, 1)
        }
        if (upperLayoutId.length > upperLevel) {
          upperLayoutId = upperLayoutId.join("_")
          console.log("upperLayoutId", upperLayoutId)
          firstBtn = getContainerInfo(
            pageLayoutType,
            {
              container_id: ids.container_id,
              parentRectId: ids.rect_id,
              pageLayoutId: upperLayoutId
            },
            stage,
            isShowVerticalTabs,
            isAccordionLayout
          )
        } else {
          firstBtn = {
            name: "页面",
            iconClass: "icon-portal-page-layer",
            shape: "page",
            ids: {}
          }
        }
        // }
        // firstBtn = getContainerInfo(
        //   pageLayoutType,
        //   {
        //     container_id: ids.container_id,
        //     parentRectId: ids.rect_id,
        //     pageLayoutId: layoutIndex
        //   },
        //   stage
        // )
      } else {
        firstBtn = {
          name: "布局",
          iconClass: "icon-portal-container",
          shape: "cxPageLayoutCell",
          ids: {
            container_id: ids.container_id,
            pageLayoutId: cxPageLayoutId
          }
        }
        // firstBtn = {
        //   name: "通栏",
        //   iconClass: "icon-portal-artboard_1",
        //   shape: "cxPageLayout",
        //   ids: {
        //     container_id: ids.container_id,
        //     pageLayoutId: cxPageLayoutId
        //   }
        // }
      }
    }
    // 自动布局中的元素
    else if (isExist(ids.elementInAutoLayoutId)) {
      let firstId = undefined
      let firstPath = undefined
      let secondId = undefined
      let secondPath = undefined
      if (!isExist(ids.path) || ids.path.length === 0) {
        secondBtn = {
          name: autoLayout?.menuName,
          iconClass: autoLayout?.menuIconClass,
          shape: "cxAutoLayout",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id
          }
        }
        firstBtn = getContainerInfo(pageLayoutType, ids, stage, isShowVerticalTabs, isAccordionLayout)
        firstId = ids.elementInAutoLayoutId
        firstPath = ids.path
      } else {
        let pathLen = ids.path.length
        let tempPath = JSON.parse(JSON.stringify(ids.path))
        firstId = ids.path[pathLen - 1]
        tempPath.pop()
        firstPath = tempPath.length > 0 ? tempPath.slice(-2) : []
        secondBtn = {
          name: autoLayout?.menuName,
          iconClass: autoLayout?.menuIconClass,
          shape: "cxAutoLayout",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id,
            elementInAutoLayoutId: firstId,
            path: firstPath
          }
        }
        secondId = pathLen > 1 ? ids.path[pathLen - 2] : undefined
        tempPath.pop()
        secondPath = tempPath.length > 0 ? tempPath.slice(-2) : []
        firstBtn = {
          name: autoLayout?.menuName,
          iconClass: autoLayout?.menuIconClass,
          shape: "cxAutoLayout",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id,
            elementInAutoLayoutId: secondId,
            path: secondPath
          }
        }
      }
      // 自动布局中的自由布局的侧边栏
      if (isExist(ids.directionIndex) && isExist(ids.elementInLayoutId)) {
        secondBtn = {
          name: emptyLayout?.menuName,
          iconClass: emptyLayout?.menuIconClass,
          shape: "emptyLayoutComponent",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id,
            elementInAutoLayoutId: ids.elementInAutoLayoutId,
            path: ids.path
          }
        }
        firstBtn = {
          name: autoLayout?.menuName,
          iconClass: autoLayout?.menuIconClass,
          shape: "cxAutoLayout",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id,
            elementInAutoLayoutId: secondId,
            path: firstPath
          }
        }
      }
      // 轮播里的组件
      if (isExist(ids.swiperContent_id) && isExist(ids.elementInSwiperId)) {
        secondBtn = {
          name: "单元格",
          iconClass: "icon-portal-grid",
          shape: "swiperComponent",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id,
            swiperContent_id: ids.swiperContent_id,
            elementInAutoLayoutId: ids.elementInAutoLayoutId,
            path: ids.path
          }
        }
        firstBtn = {
          name: "轮播",
          iconClass: "icon-portal-menu_swiper",
          shape: "swiperComponent",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id,
            elementInAutoLayoutId: ids.elementInAutoLayoutId,
            path: ids.path
          }
        }
      }
      // 数据列表的单元格中的组件
      if (isExist(ids.cellId) && isExist(ids.elementInDataGridId)) {
        firstBtn = {
          name: "列表页数据",
          iconClass: "icon-portal-free_layout",
          shape: "cxDataGrid",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id,
            elementInAutoLayoutId: ids.elementInAutoLayoutId,
            path: ids.path
          }
        }
        secondBtn = {
          name: "单元格",
          iconClass: "icon-portal-grid",
          shape: "cxDataGridCell",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id,
            cellId: ids.cellId,
            elementInAutoLayoutId: ids.elementInAutoLayoutId,
            path: ids.path
          }
        }
      }
      // 数据列表的单元格
      if (isExist(ids.cellId) && !isExist(ids.elementInDataGridId)) {
        firstBtn = getContainerInfo(pageLayoutType, ids, stage, isShowVerticalTabs)
        secondBtn = {
          name: "列表页数据",
          iconClass: "icon-portal-free_layout",
          shape: "cxDataGrid",
          ids: {
            container_id: ids.container_id,
            rect_id: ids.rect_id,
            elementInAutoLayoutId: ids.elementInAutoLayoutId,
            path: ids.path
          }
        }
      }
    }
    // 自由布局边栏中的组件
    else if (isExist(ids.directionIndex) && isExist(ids.elementInLayoutId)) {
      secondBtn = {
        name: emptyLayout?.menuName,
        iconClass: emptyLayout?.menuIconClass,
        shape: "emptyLayoutComponent",
        ids: {
          container_id: ids.container_id,
          rect_id: ids.rect_id
        }
      }
      firstBtn = getContainerInfo(pageLayoutType, ids, stage, isShowVerticalTabs, isAccordionLayout)
    }
    // 轮播里的组件
    else if (isExist(ids.swiperContent_id) && isExist(ids.elementInSwiperId)) {
      secondBtn = {
        name: "单元格",
        iconClass: "icon-portal-grid",
        shape: "swiperComponent",
        ids: {
          container_id: ids.container_id,
          rect_id: ids.rect_id,
          swiperContent_id: ids.swiperContent_id
        }
      }
      firstBtn = {
        name: "轮播",
        iconClass: "icon-portal-menu_swiper",
        shape: "swiperComponent",
        ids: {
          container_id: ids.container_id,
          rect_id: ids.rect_id
        }
      }
    }
    // 轮播的单元格
    else if (isExist(ids.swiperContent_id) && !isExist(ids.elementInSwiperId)) {
      secondBtn = {
        name: "轮播",
        iconClass: "icon-portal-menu_swiper",
        shape: "swiperComponent",
        ids: {
          container_id: ids.container_id,
          rect_id: ids.rect_id
        }
      }
      firstBtn = getContainerInfo(pageLayoutType, ids, stage, isShowVerticalTabs, isAccordionLayout)
    }
    // 数据列表的单元格
    else if (isExist(ids.cellId) && !isExist(ids.elementInDataGridId)) {
      firstBtn = getContainerInfo(pageLayoutType, ids, stage, isShowVerticalTabs)
      secondBtn = {
        name: "列表页数据",
        iconClass: "icon-portal-free_layout",
        shape: "cxDataGrid",
        ids: {
          container_id: ids.container_id,
          rect_id: ids.rect_id
        }
      }
    }
    // 数据列表的单元格中的组件
    else if (isExist(ids.cellId) && isExist(ids.elementInDataGridId)) {
      firstBtn = {
        name: "列表页数据",
        iconClass: "icon-portal-free_layout",
        shape: "cxDataGrid",
        ids: {
          container_id: ids.container_id,
          rect_id: ids.rect_id
        }
      }
      secondBtn = {
        name: "单元格",
        iconClass: "icon-portal-grid",
        shape: "cxDataGridCell",
        ids: {
          container_id: ids.container_id,
          rect_id: ids.rect_id,
          cellId: ids.cellId
        }
      }
    }
    // 布局
    else if (!isExist(ids.rect_id) && isExist(ids.pageLayoutId)) {
      let pageLayoutLevel = ids.pageLayoutId.toString().split("_")
      secondBtn = getContainerInfo(pageLayoutType, ids, stage, isShowVerticalTabs)
      if (pageLayoutLevel.length > 1) {
        let upperLayoutId = ids.pageLayoutId.toString().split("_")
        upperLayoutId.splice(-1, 1)
        if (upperLayoutId.length > 1) {
          upperLayoutId = upperLayoutId.join("_")
          firstBtn = getContainerInfo(
            pageLayoutType,
            {
              ...ids,
              pageLayoutId: upperLayoutId
            },
            stage,
            isShowVerticalTabs
          )
        } else {
          firstBtn = {
            name: "页面",
            iconClass: "icon-portal-page-layer",
            shape: "page",
            ids: {}
          }
        }
      }
    }
  }
  if (secondBtn) handleList.splice(0, 0, secondBtn)
  if (firstBtn) handleList.splice(0, 0, firstBtn)
  return handleList
}
// 获取默认的uid展示顺序
export function getDefaultColsUidInLayoutComponent(options) {
  const topRows = options.rows || options.cols ? options : Array.isArray(options) ? options[0] : [options]
  const copyTopRows = JSON.parse(JSON.stringify(topRows))
  copyTopRows.top = 0
  copyTopRows.left = 0
  copyTopRows.height = 100
  copyTopRows.width = 100
  const leafNodes = []
  travelLayout(copyTopRows, leafNodes)
  // 默认按照top排序，相同的话，按照left排序
  leafNodes.sort((a, b) => {
    return a.top - b.top || a.left - b.left
  })
  const colsIdFromActiveRect = leafNodes.map(node => node.uid)
  return colsIdFromActiveRect
}

// 获取只剩最后一个叶子节点
export function findLastLeafLayout(options) {
  let lastLeaf = options
  while (lastLeaf.rows || lastLeaf.cols) {
    lastLeaf = lastLeaf.rows ? lastLeaf.rows[0] : lastLeaf.cols[0]
  }
  return lastLeaf
}

/**
 * 获取需要展示的有效的uid上级（过滤层级大小一致的）
 * @param options 行列配置信息
 * @param uid 要查找的uid
 * @returns 父级集合
 */
export function getEffectiveLayoutUid(options, uid, stage) {
  const pUidMap = {}
  const pNumMap = {}
  const uids = []
  function travel(options, pUid) {
    if (options && options.cols) {
      options.cols.forEach(col => {
        travel(col, pUid)
      })
    } else if (options && options.rows) {
      let uid = options.uid
      pUidMap[uid] = pUid
      pNumMap[uid] = 0
      options.rows.forEach(row => {
        travel(row, options.uid)
      })
    } else {
      let uid = options.uid
      pUidMap[uid] = pUid
      pNumMap[uid] = 1
      while (pUid) {
        pNumMap[pUid]++
        pUid = pUidMap[pUid]
      }
    }
  }
  travel(options, null)
  const isAdmin = getRequest().admin
  if (isAdmin) {
    while (pUidMap[uid]) {
      // admin显示所有层级
      uids.push(pUidMap[uid])
      uid = pUidMap[uid]
    }
  } else {
    while (pUidMap[uid]) {
      // 从内到外遍历父级节点，只显示尺寸大小不一致的父级，减少包裹层级查找
      if (pNumMap[pUidMap[uid]] > pNumMap[uid]) {
        uids.push(pUidMap[uid])
      } else if (pNumMap[pUidMap[uid]] === pNumMap[uid] && uids[uids.length - 1] === uid) {
        // 大小一致的，且内容已经放入队，取外层的
        uids.pop()
        uids.push(pUidMap[uid])
      }
      uid = pUidMap[uid]
    }
  }
  return uids
}

/**
 * 获取移动状态
 * @param {*} options
 * @param {*} uid
 * @returns
 */
export function getMoveStatus(options, uid) {
  const moveStatus = {
    top: false,
    right: false,
    bottom: false,
    left: false
  }
  const pMap = {}
  function travel(options, idx, pRows) {
    if (options.cols) {
      options.cols.forEach((col, index) => {
        if (col.uid === uid) {
          moveStatus.left = index > 0
          moveStatus.right = index < options.cols.length - 1
          moveStatus.top = idx > 0
          moveStatus.bottom = pRows ? idx < pRows.length - 1 : false
        } else {
          travel(col)
        }
      })
    } else if (options.rows) {
      options.rows.forEach((row, idx) => {
        travel(row, idx, options.rows)
      })
    }
  }
  travel(options)
  return moveStatus
}

// 根据自由布局的uid，获取所在的最外层rows的下标
export function findRowIndexByUid(options, uid) {
  let activeIndex = 0
  const travel = (data, rowIndex) => {
    if (data.cols && data.cols.length > 0) {
      for (let i = 0; i < data.cols.length; i++) {
        if (data.cols[i].uid === uid) {
          activeIndex = rowIndex
          return
        }
        if (data.cols[i].rows && data.cols[i].rows.length > 0) {
          for (let j = 0; j < data.cols[i].rows.length; j++) {
            travel(data.cols[i].rows[j], rowIndex)
          }
        }
      }
    }
  }
  for (let i = 0; i < options.rows.length; i++) {
    travel(options.rows[i], i)
  }
  return activeIndex
}
/**
 * content空格箭头替换处理
 * @param type true:替换 false:转回去
 */
export function mhxssEncodeFunc(str, type) {
  var result = str
  if (!result) return result
  if (type) {
    result = result.replace("onclick", "mh-func-1")
    result = result.replace("<script>", "<mh-tag-1>")
    result = result.replace("</script>", "</mh-tag-1>")
    result = result.replace(/ /g, "[[AA]]")
    result = result.replace(/</g, "[[BB]]")
    result = result.replace(/>/g, "[[CC]]")
  } else {
    result = result.replaceAll("mh-func-1", "onclick")
    result = result.replaceAll("<mh-tag-1>", "<script>")
    result = result.replaceAll("</mh-tag-1>", "</script>")
    result = result.replaceAll("[[AA]]", " ")
    result = result.replaceAll("[[BB]]", "<")
    result = result.replaceAll("[[CC]]", ">")
  }
  return result
}

/**
 * 获取查询参数
 * @returns
 */
export function getRequest() {
  var url = window.previewUrl || location.href //获取url中"?"符后的字串
  var theRequest = new Object()
  if (url.indexOf("?") != -1) {
    var str = url.split("?")[1]
    var strs = str.split("&")
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
    }
  }
  return theRequest
}

// 根据链接跳转类型、是否携带系统参数来拼接跳转地址
export function spliceLinkUrl($this) {
  let targetUrl = ""
  const linkAddress = $this?.options?.linkAddress || "自定义"
  const linkUrl = $this?.options?.linkUrl || $this?.options?.iframeUrl
  const accessRulers = $this?.options?.accessRulers || []
  try {
    if (linkAddress === "自定义" && linkUrl && accessRulers?.includes("传递门户参数")) {
      const cookie = $this.$store.state.states.myCookie
      const { pageId } = $this.$store.state.states.getDataPageIds
      const linkParams = {
        pageId: cookie?.current_page_id,
        websiteId: cookie?.website_id,
        wfwfid: cookie?.website_fid,
        uid: cookie?.UID,
        publicId: pageId,
        mhType: 2
      }
      ;["pageId", "websiteId", "wfwfid", "uid", "publicId", "mhType"].forEach(key => {
        targetUrl = replaceUrlParam(targetUrl || linkUrl, key, linkParams[key])
      })
    }
  } catch (e) {
    targetUrl = ""
    console.error(e)
  }
  return targetUrl
}

// 自定义订阅发布类
export class EventEmitter {
  constructor(eventMap) {
    this.eventMap = eventMap
    this.dataMap = {}
    this.handlers = {}
  }
  on(eventName, obj) {
    if (!this.handlers[eventName]) {
      this.handlers[eventName] = []
    }
    this.handlers[eventName].push(obj)
  }
  emit(eventName, ...args) {
    if (this.handlers[eventName]) {
      const handlers = this.handlers[eventName].slice()
      handlers.forEach(handler => {
        handler.callback(...args)
      })
    }
  }
  off(eventName, id) {
    if (this.handlers[eventName]) {
      const handlers = this.handlers[eventName]
      const index = handlers.findIndex(handler => handler.id === id)
      if (index !== -1) {
        handlers.splice(index, 1)
      }
    }
  }
}

/**
 *  @description 删除页面
 *  @param {*} pageId
 */
export function deletePage(pageId) {
  let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
  return api.deletePage({
    pageId: pageId
  })
}

// 记录自由布局原始尺寸
export function recordOldSize(options, copyObj) {
  const { oldRowsLength, oldColsLength, tabsList = [], rows, activeIndex, categoryMode } = options
  const useActiveIndex = categoryMode === CATEGORY_MODE.SAME ? 0 : activeIndex
  const oldRowsLen = Object.prototype.toString.call(oldRowsLength) === "[object Object]" ? oldRowsLength : {}
  const oldColsLen = Object.prototype.toString.call(oldColsLength) === "[object Object]" ? oldColsLength : {}
  const rowsLength = {}
  const colsLength = {}
  let changed = false
  if (tabsList.length !== 0 && Object.keys(oldRowsLen).length !== tabsList.length) {
    changed = true
  }
  if (tabsList.length === 0) {
    const id = useActiveIndex
    if (oldRowsLen.hasOwnProperty(id)) {
      rowsLength[id] = oldRowsLen[id]
      colsLength[id] = oldColsLen[id]
    } else {
      const { rowLens, colLens } = checkIrregularLayout([rows[useActiveIndex]])
      rowsLength[id] = rowLens
      colsLength[id] = colLens
      changed = true
    }
  } else {
    tabsList.forEach((tab, index) => {
      const id = tab.id || 0
      if (oldRowsLen.hasOwnProperty(id)) {
        if (copyObj && copyObj.copy.includes(id)) {
          rowsLength[id] = oldRowsLen[copyObj.target]
          colsLength[id] = oldColsLen[copyObj.target]
          changed = true
        } else {
          rowsLength[id] = oldRowsLen[id]
          colsLength[id] = oldColsLen[id]
        }
      } else {
        // 处理脏数据
        if (rows[index]) {
          const { rowLens, colLens } = checkIrregularLayout([rows[index]])
          rowsLength[id] = rowLens
          colsLength[id] = colLens
          changed = true
        }
      }
    })
  }
  if (changed) {
    this.$changeOptionsEV(
      rowsLength,
      "oldRowsLength",
      false,
      null,
      {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      },
      true
    )
    this.$changeOptionsEV(
      colsLength,
      "oldColsLength",
      false,
      null,
      {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      },
      true
    )
  }
}

/* 查找通栏组件中的组件所在的通栏中的位置 */
export function findPathInComponentLayoutByRectId(ids) {
  let parentRect, parentRectId, pageLayoutId
  if (!(isExist(ids.rect_id) && isExist(ids.container_id) && !isExist(ids.pageLayoutId))) return [false, false]
  parentRect = $(`.container_id_${ids.container_id}-rect_id_${ids.rect_id}`)?.parents(".layout-columns")[0]
  if (parentRect) {
    let columnsId = parentRect.getAttribute("id")
    if (columnsId.indexOf("rect_id_") > -1 && columnsId.indexOf("_layout_") > -1) {
      columnsId = columnsId.split("_layout_")
      pageLayoutId = columnsId[1]
      parentRectId = columnsId[0].split("rect_id_")[1]
    } else return [false, false]
  }
  return [
    Number(parentRectId),
    pageLayoutId
  ]
}
// 判断当前元素是否在自动布局中
export function isInAutoLayout(stage, ids, options) {
  if (stage.type === "bigScreen") return false
  if (ids.hasOwnProperty("elementInAutoLayoutId")) {
    // 新增自动布局中放数据列表的逻辑
    if (ids.hasOwnProperty("elementInDataGridId")) {
      let tempRect = getAttrById(stage, ids, "dataGridCell")?.options
      return tempRect.showRowColLayout
    }
    if (!options.hasOwnProperty("elementInAutoLayoutId")) return false
    // todo_zxf
    let tempRect = getAttrById(stage, ids, "autoLayout")
    return tempRect.showRowColLayout
  } else if (ids.hasOwnProperty("elementInLayoutId")) {
    if (!options.hasOwnProperty("elementInLayoutId")) return false
    let tempRect = getAttrById(stage, {
      container_id: ids.container_id,
      rect_id: ids.rect_id,
      uid: ids.uid
    })
    if (!tempRect) return false
    const rectOptions = tempRect.options ? tempRect.options : tempRect
    const useActiveIndex = rectOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : rectOptions.activeIndex
    const pOptions = [rectOptions.rows[useActiveIndex]]
    if (!pOptions) return false
    const activeCol = handleFindLayoutComponentOptionsCols(pOptions, ids.uid) ||
        handleFindLayoutComponentOptionsCols(pOptions, pOptions[0]?.cols[0]?.uid)
    if (!activeCol || !activeCol?.componentBoxOptions) return false
    return activeCol.componentBoxOptions.showRowColLayout
  } else if (ids.hasOwnProperty("elementInDataGridId")) { // 新增放在数据列表的逻辑
    let tempRect = getAttrById(stage, ids, "dataGridCell")?.options
    return tempRect.showRowColLayout
  } else if (Object.keys(ids).length === 2) {
    if (ids.hasOwnProperty("container_id") && ids.hasOwnProperty("rect_id")) {
      let pageLayoutList = stage.page.pageLayoutList || []
      const path = findCurrentComponentPathInLayoutByRectId(pageLayoutList, ids.rect_id).join("_")
      let parentRectId, pageLayoutId
      if (!path) {
        if (isExist(ids.rect_id) && !isExist(ids.pageLayoutId)) {
          ;[ parentRectId, pageLayoutId ] = findPathInComponentLayoutByRectId(ids)
        }
        if (!parentRectId) return false
      }
      let pageLayout
      if (parentRectId) {
        pageLayout = getAttrById(stage, {
          container_id: ids.container_id,
          rect_id: Number(parentRectId),
          pageLayoutId: pageLayoutId
        })
      } else {
        pageLayout = getAttrById(stage, {
          container_id: ids.container_id,
          pageLayoutId: path
        })
      }
      return pageLayout ? pageLayout?.options?.showRowColLayout : false
    }
  }
}
//区分不同组件的option_name不一致的问题
export function fixOptName(shape) {
  if (shape.find(it => it === "cxVideo")) {
    return "videoUrl"
  } else if (shape.find(it => it === "cxAudio")) {
    return "audioUrl"
  } else if (shape.find(it => it === "cxCode")) {
    return "linkUrlVal"
  } else if (shape.find(it => it.includes("NavMenu") || it === "cxMultiFilter" || it === "cxSelect")) {
    return "selectOptions"
  } else if (shape.find(it => it === "cxTabs")) {
    return "tabsList"
  } else if (shape.find(it => it === "cxTable")) {
    return "listData"
  } else if (shape.find(it => it === "imageComponent")) {
    return "imgSrc"
  } else if (shape.find(it => it === "cxBreadCrumbs")) {
    return "sorceData"
  } else if (shape.find(it => it === "cxPagination")) {
    return "innerElement"
  } else {
    return "content"
  }
}
// 判断某个字段是不是全部为空
export function isFieldAllEmpty(datas, field) {
  // 把所有字段都放开
  return false
}

// 隐藏组件的样式悬浮预览效果
export function hidePreviewStyle(options) {
  return ["cxButton", "cxWeather"].includes(options.innerElement) || options.menuName === "登录组件"
}

// 判断是否为移动端
export function isMobile() {
  var devices = [
    /phone|pad|pod|iPhone|iPod|ios|iPad|android|mobile|tablet|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i,
    /(archos)\s(gamepad2?)/i,
    /(hp).+(touchpad)/i,
    /\s(nook)[\w\s]+build\/(\w+)/i,
    /(dell)\s(strea[kpr\s\d]*[\dko])/i,
    /\((ip[honed|\s\w*]+);/i,
    /(benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
    /(hp)\s([\w\s]+\w)/i,
    /(asus)-?(\w+)/i,
    /(sony)?(?:sgp.+)\sbuild\//i,
    /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i,
    /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,
    /(zte)-(\w+)*/i,
    /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i,
    /d\/huawei([\w\s-]+)[;\)]/i,
    /(microsoft);\s(lumia[\s\w]+)/i,
    /(kin\.[onetw]{3})/i,
    /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
    /mot[\s-]?(\w+)*/i,
    /(XT\d{3,4}) build\//i,
    /((SM-T\w+))/i,
    /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
    /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
    /sec-((sgh\w+))/i,
    /sie-(\w+)*/i,
    /(maemo).*(n900|lumia\s\d+)/i,
    /lg[e;\s\/-]+(\w+)*/i,
    /linux;.+((jolla));/i,
    /crkey/i,
    /ChaoXingStudy.*phone/i
  ]
  function rgx(ua, arrays) {
    var i = 0,
      isMatch = false
    while (i < arrays.length && !isMatch) {
      var regex = arrays[i]
      isMatch = !!regex.exec(ua)
      if (!isMatch) {
        i++
      } else {
        break
      }
    }
    return isMatch
  }
  function isMobileAndTabletType() {
    var nav = window.navigator
    var ua = nav.userAgent
    return rgx(ua, devices)
  }
  function isIOS13Check(type) {
    var nav = window.navigator
    var type = "iPad"
    return (
      nav &&
      nav.platform &&
      (nav.platform.indexOf(type) !== -1 || (nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream))
    )
  }
  return isMobileAndTabletType() || isIOS13Check()
}

// 获取指定查询参数
export function getQueryParam(target) {
  const search = location.search
  if (!search) {
    return ""
  }
  const searchParams = new URLSearchParams(search)
  return searchParams.get(target)
}
// 获取错误码
export function getErrorCode(message) {
  if (!message) return ""
  let codeReg = /^mh_portal_(\d+)$/
  let errorCode = message
  if (message.indexOf("engine") > -1) {
    codeReg = /^mh_engine_(\d+)$/
  } else {
    codeReg = /^mh_portal_(\d+)$/
  }
  errorCode = codeReg.exec(message)
  return errorCode[1]
}

/**
 * 修改options值
 * @param {*} tempRect
 * @param {*} data
 */
export function changeOption(tempRect, data) {
  if (Array.isArray(data.option_name)) {
    for (let i in data.option_name) {
      changeSingleOption(tempRect, data.option_name[i], data.option_val[i])
    }
  } else {
    changeSingleOption(tempRect, data.option_name, data.option_val)
  }
}

function changeSingleOption(tempRect, option_name, option_val) {
  let tempObj = {}
  let nameMap = option_name.split(".")
  let lastName = nameMap[nameMap.length - 1]
  if (nameMap.length > 1) {
    nameMap.pop()
    for (let i = 0; i < nameMap.length; i++) {
      if (!i) {
        tempObj = tempRect[nameMap[i]]
      } else {
        tempObj = tempObj[nameMap[i]]
      }
      if (tempObj === undefined) {
        console.log(`${nameMap[i]}不存在，请检查option_name:${option_name}`)
        return
      }
    }
    Vue.set(tempObj, lastName, option_val)
  } else {
    if (!tempRect) return
    Vue.set(tempRect, lastName, option_val)
  }
}

export function remCheck(value) {
  if (value?.endsWith && value?.endsWith("rem")) {
    // 说明是已经被系统转换过的单位了
    return value
  }
  return parseFloat(value) + "px"
}

export function isPlainObject(target) {
  return Object.prototype.toString.call(target) === "[object Object]"
}

export function customUnitTranform(name, value) {
  if (PXRESEVERPROP.includes(name) && !Array.isArray(value)) {
    return remCheck(value)
  }
  if (ARRAYPXRESEVERPROP.includes(name)) {
    return Array.isArray(value) ? value.map(item => remCheck(item)).join(" ") : remCheck(value)
  }
  return value
}

export function getDiffVal(currentVal, defaultVal) {
  if (typeof currentVal !== "object") return currentVal
  const target = {}
  Object.entries(currentVal).forEach(([key, value]) => {
    if (value != defaultVal[key]) {
      target[key] = value
    }
  })
  return target
}
// 清理掉 ids里无用的属性
export function clearIds(ids) {
  for (let key in ids) {
    if (ids[key] === null || typeof ids[key] === "undefined") {
      delete ids[key]
    }
  }
}

// 在rects中找头部组件
/**
 *
 * @param {*} rects rects数组
 * @param {*} type 搜索组件类型 nav logo login
 * @param {*} rectId rectId
 * @param {*} config 是否返回配置
 * @returns
 */
export function findRectPath(rects, type, rectId, config) {
  if (rectId) {
    rects = rects.filter(item => item.rect_id === rectId)
  }
  let res = null
  const map = {
    nav: "cxNavMenu",
    logo: "imageComponent",
    login: "emptyLayoutComponent"
  }
  for (const rect of rects) {
    if (rect?.shape === "cxAutoLayout") {
      const element = rect.elementOptions.find(item => {
        if (type === "login") {
          return (
            item.innerElement === map[type] &&
            item.pluginName &&
            item.pluginName.find(name => name === "loginLayoutComponent")
          )
        } else {
          return item.innerElement === map[type]
        }
      })
      if (element) {
        if (config) {
          res = element
        } else {
          res = {
            container_id: 0,
            rect_id: rect.rect_id,
            elementInAutoLayoutId: element.elementInAutoLayoutId
          }
        }
      }
    } else if (rect?.shape) {
      if (rect.shape === map[type]) {
        if (config) {
          res = rect
        } else {
          res = { container_id: 0, rect_id: rect.rect_id }
        }
      }
    }
    if (res) {
      break
    }
  }
  return res
}
// 查找当前组件所在的自由布局
export function findLayoutOptions($this, ids) {
  const stage = $this.$store.state[$this.request_prefix]
  let rectAttr = getAttrById(stage, ids, "rect")?.options

  if (rectAttr && isExist(ids.elementInAutoLayoutId) && (isExist(ids.elementInLayoutId) || isExist(ids.elementInSwiperId)) && rectAttr.innerElement === "cxAutoLayout") {
    rectAttr = getAttrById(stage, { ...ids, elementInLayoutId: undefined })
  }
  if (rectAttr && rectAttr.innerElement !== "emptyLayoutComponent" && rectAttr.innerElement !== "layoutComponent" && rectAttr.innerElement !== "swiperComponent") return {}
  return rectAttr
}

/**
 * 对比两个对象的属性是否相同
 * @param {*} obj1
 * @param {*} obj2
 */
export function objectEqual(obj1, obj2) {
  const obj1Props = Object.keys(obj1);
  const obj2Props = Object.keys(obj2);
  if (obj1Props.length !== obj2Props.length) return false;
  for (let prop of obj1Props) {
    if (obj1[prop] !== obj2[prop]) return false;
  }
  return true;
}

export function smartMathMax() {
  var args = [...arguments].filter(item => !isNaN(item))
  return  args?.length ? Math.max(...args) : 0
}

/**
 * 复制文本到剪切板
 * @param {*} text 
 */
export function copyTextToClipboard(text) {
  const textArea = document.createElement("textarea")
  textArea.value = text

  // 避免在 iOS 设备上滚动
  textArea.style.position = "fixed"
  textArea.style.top = "0"
  textArea.style.left = "0"
  textArea.style.width = "2em"
  textArea.style.height = "2em"
  textArea.style.padding = "0"
  textArea.style.border = "none"
  textArea.style.outline = "none"
  textArea.style.boxShadow = "none"
  textArea.style.background = "transparent"

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    const successful = document.execCommand("copy")
    const msg = successful ? "成功" : "失败"
    console.log("复制文本命令: " + msg)
  } catch (err) {
    console.error("无法复制文本: ", err)
  }

  document.body.removeChild(textArea)
}

// 判断是否是云舟数据源
export function checkIsYzDatacenter(styleId) {
  return YZ_DATACENTER_TYPES.map(item => item.id)?.includes(styleId)
}
// 判断是否是复杂组件内部组件
export function elementInComplexComponent(ids) {
  if (!ids) return false
  return isExist(ids.directionIndex) || isExist(ids.elementInLayoutId) || isExist(ids.elementInSwiperId) || isExist(ids.elementInAutoLayoutId) || isExist(ids.elementInDataGridId)
}

/**
 * 格式化数据中心查询参数
 * @param {*} queryString
 * @returns
 */
export function parseQueryString(queryString) {
  const result = {}
  const pairs = queryString.split("&")
  pairs.forEach(pair => {
    const [key, value] = pair.split("=")
    try {
      result[key] = JSON.parse(value);
    } catch (e) {
      result[key] = value;
    }
  })
  return result
}
/**
 * 重新组装通栏
 * @param {*} queryString
 * @returns
 */
export function comparePageLayoutList(result, isApp){
  if(!result.page.clonePageLayout || !result.page.pageLayoutList){
    return
  }
  if(result.page.clonePageLayout.length !== result.page.pageLayoutList.length){
    // 长度不等的时候放过
    return
  }
  let tempPageLayout = []
  result.page.clonePageLayout.forEach((item,index)=>{
    let oldIndex = result.page.pageLayoutList.findIndex(layout=>layout.id === item.id)
    if(oldIndex > -1 ){
      let options = result.page.pageLayoutList[oldIndex].options
      if(options.inDocument === 'none' && !item.disabled ){
        options.isShow = item.isShow
      }
      options.name = item.name
      options.moudleStyleId = item.moudleStyleId
      tempPageLayout.push(result.page.pageLayoutList[oldIndex])
    }
  })
  // 只要PC端完成组装就通知
  if (!isApp) {
    window.parent.postMessage({
      type: "mhMoudlesInit",
      data: result.page.clonePageLayout
    }, "*")
  }
  result.page.pageLayoutList = tempPageLayout
}
/**
 * webjson初始化前处理
 * @param {*} stage
 */
export function handleWebjsonBeforeInit(stage, isApp) {
  comparePageLayoutList(stage, isApp)
  stage.page.children.forEach(pageChildren => {
    pageChildren.children.forEach(item => {
      // 这些组件比较特殊，需要处理一下CATEGORY_MODE属性
      if (
        item.shape === "emptyLayoutComponent" &&
        (item.options.pluginName?.includes["loginLayoutComponent"] ||
          item.options.pluginName?.includes["searchComponentPlugin"] ||
          item.options.pluginName?.includes["loginEngineComponentPlugin"] ||
          item.options.menuName === "超星头像" ||
          item.options.name === "超星头像") &&
        item.options.categoryMode === CATEGORY_MODE.SAME
      ) {
        delete item.options.categoryMode
      }
    })
  })
}
